import React, { Component } from 'react'
import gql from 'graphql-tag'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import { Query, withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Select from 'react-select'
import getLoginId from '../../../utils/getLoginId'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import FormHelperText from '@material-ui/core/FormHelperText'
import moment from 'moment'
import { DateTimePicker } from 'material-ui-pickers'
import { Checkbox, Switch, Typography } from '@material-ui/core'
import Loader from '../../../components/common/Loader'
import ConfirmationalDialog from '../../common/ConfirmationDialog'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Countries from '../../Modules/Countries'
import convertToSnakeCase from '../../../utils/conertSnakeFormat'
import functionTakeAndGiveVideoTeleValue from '../../../utils/videoTelimatricsValues'
import { ThumbsUpDown } from '@material-ui/icons'
import InputLabel from '@material-ui/core/InputLabel'
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  italicizedText: {
    fontStyle: 'italic'
  }
})

const GET_CLIENT = gql`
  query clientDetail($loginId: Int) {
    clientDetail(loginId: $loginId) {
      id
      loginId
      clientName
      prorata
      contactPerson
      secondaryContactName
      secondaryEmail
      secondaryContactNumber
      additionalContactNumbers
      address
      clientType
      registrationType
      shippingAddress
      shippingCity
      shippingPincode
      city
      timezone
      minimumTrackedDays
      packetThreshold
      gst
      state {
        zone_id
      }
      country {
        country_id
      }
      shippingState {
        zone_id
      }
      shippingCountry {
        country_id
      }
      email
      contactNumber
      login {
        username
      }
      plan {
        id
        planName
      }
      pincode
      panNumber
      type
      expiryDate
      solution

      billingMode {
        id
        billingMode
      }
      salesPerson {
        id
        name
      }
      zonalManager
      stateManager
      territoryManager
      salesHead
      clusterHead
      stateHead
      cityManager
      operationsManager
      keyAccountManager
      channelPartnerName
      litemode
      is_sim_tracking
      totalPotentialVehicles
      videoTelematicsType
      customerAcquisitionType
      directCustomer
      directCustomerType
      directCustomerSAPCode
      indirectCustomerType
      channelPartnerType
      indirectCustomerName
      indirectCustomerUniqueId
      customerLocation
      secondaryLandlineNumber
      channelPartnerSAPCode
      customerNameToBeDisplayed
      zone
      serviceManager
      customerSuccessManager
      serviceType
      # solutionId
      isSecondaryContact
      clientCategory
    }
  }
`

const UPDATE_CLIENT = gql`
  mutation(
    $id: Int!
    $clientName: String!
    $login_id: Int!
    $email: String!
    $contactPerson: String!
    $contactNumber: String!
    $secondaryContactName: String
    $secondaryContactNumber: String
    $secondaryEmail: String
    $additionalContactNumbers: String
    $address: String!
    $city: String!
    $state_id: Int!
    $country_id: Int!
    $pincode: Int
    $panNumber: String
    $clientType: String!
    $status: Int!
    $partnerLoginId: Int
    $registrationType: String
    $timezone: String!
    $gst: String
    $plan: Int
    $username: String!
    $shippingAddress: String
    $shippingCountry: Int
    $shippingState: Int
    $shippingCity: String
    $shippingPincode: Int
    $expiryDate: String
    $solution: String!
    $billingMode: Int!
    $salesPersonId: Int
    $prorata: Int!
    $minimumTrackedDays: Int!
    $packetThreshold: Int
    $zonalManager: String!
    $keyAccountManager: String!
    $channelPartnerName: String
    $litemode: String!
    $is_sim_tracking: Boolean
    $totalPotentialVehicles: Int!
    $videoTelematicsType: String
    $typeOfClient: ClientPartnerType
    $customerAcquisitionType: String!
    $directCustomer: String
    $directCustomerType: String
    $directCustomerSAPCode: String
    $indirectCustomerType: String
    $channelPartnerType: String
    $indirectCustomerName: String
    $indirectCustomerUniqueId: String
    $customerLocation: String!
    $zone: String!
    $secondaryLandlineNumber: String
    $serviceManager: String!
    $customerSuccessManager: String!
    $channelPartnerSAPCode: String
    $customerNameToBeDisplayed: String!
    $serviceType: String!
    $isSecondaryContact: Boolean
    $clientCategory: String!
    $stateManager: String!
    $territoryManager: String
    $salesHead: String
    $clusterHead: String
    $stateHead: String
    $cityManager: String
    $operationsManager: String
  ) {
    updateClientDetail(
      id: $id
      clientName: $clientName
      login_id: $login_id
      email: $email
      contactPerson: $contactPerson
      contactNumber: $contactNumber
      secondaryContactName: $secondaryContactName
      secondaryContactNumber: $secondaryContactNumber
      secondaryEmail: $secondaryEmail
      additionalContactNumbers: $additionalContactNumbers
      address: $address
      city: $city
      state_id: $state_id
      country_id: $country_id
      pincode: $pincode
      panNumber: $panNumber
      clientType: $clientType
      status: $status
      partnerLoginId: $partnerLoginId
      timezone: $timezone
      gst: $gst
      plan_id: $plan
      loginUsername: $username
      typeOfClient: $typeOfClient
      shippingAddress: $shippingAddress
      shippingCountry: $shippingCountry
      shippingState: $shippingState
      registrationType: $registrationType
      shippingCity: $shippingCity
      shippingPincode: $shippingPincode
      expiryDate: $expiryDate
      solution: $solution
      billingMode: $billingMode
      salesPersonId: $salesPersonId
      minimumTrackedDays: $minimumTrackedDays
      packetThreshold: $packetThreshold
      prorata: $prorata
      zonalManager: $zonalManager
      keyAccountManager: $keyAccountManager
      channelPartnerName: $channelPartnerName
      litemode: $litemode
      is_sim_tracking: $is_sim_tracking
      totalPotentialVehicles: $totalPotentialVehicles
      videoTelematicsType: $videoTelematicsType
      customerAcquisitionType: $customerAcquisitionType
      directCustomer: $directCustomer
      directCustomerType: $directCustomerType
      directCustomerSAPCode: $directCustomerSAPCode
      indirectCustomerType: $indirectCustomerType
      channelPartnerType: $channelPartnerType
      indirectCustomerName: $indirectCustomerName
      indirectCustomerUniqueId: $indirectCustomerUniqueId
      customerLocation: $customerLocation
      secondaryLandlineNumber: $secondaryLandlineNumber
      channelPartnerSAPCode: $channelPartnerSAPCode
      customerNameToBeDisplayed: $customerNameToBeDisplayed
      zone: $zone
      serviceManager: $serviceManager
      customerSuccessManager: $customerSuccessManager
      serviceType: $serviceType
      isSecondaryContact: $isSecondaryContact
      clientCategory: $clientCategory
      stateManager: $stateManager
      territoryManager: $territoryManager
      salesHead: $salesHead
      clusterHead: $clusterHead
      stateHead: $stateHead
      cityManager: $cityManager
      operationsManager: $operationsManager
    )
  }
`

const GET_ALL_PLANS = gql`
  query getAllPlans($partnerLoginId: Int!) {
    allPlans: getAllPlans(partnerLoginId: $partnerLoginId) {
      id
      planName
    }
  }
`

const GET_ALL_SOLUTION_TYPE_MASTER = gql`
  query GetAllMasterSolutionType {
    getAllMasterSolutionType {
      id
      solutionTypeName
    }
  }
`

// Business name validation
const GET_CLIENT_NAME = gql`
  query checkClientName($businessname: String!, $id: Int) {
    checkClientName(clientName: $businessname, id: $id)
  }
`

// Business name validation
const GET_CONTACTNO = gql`
  query checkClientContactNumber($phoneno: String!, $id: Int) {
    checkClientContactNumber(contactNumber: $phoneno, id: $id)
  }
`

// Business email validation
const GET_EMAIL = gql`
  query checkClientEmail($email: String!, $id: Int) {
    checkClientEmail(email: $email, id: $id)
  }
`

// Business pan validation
const GET_PAN_NUMBER = gql`
  query checkClientPanNumber($pan: String!, $id: Int) {
    checkClientPanNumber(panNumber: $pan, id: $id)
  }
`

// Checking GST Number exist in DB or not
const GET_GST_NUMBER = gql`
  query checkClientGST($gst: String!) {
    checkClientGST(GST: $gst)
  }
`
// username validation
const GET_USERNAME = gql`
  query checkUsername($username: String!, $id: Int) {
    checkUsername(username: $username, loginId: $id)
  }
`

const GET_ALL_SALESPERSON = gql`
  query getAllSalesPerson($partnerLoginId: Int) {
    getAllSalesPerson(partnerLoginId: $partnerLoginId) {
      id
      name
    }
  }
`

const GET_COUNTRIES = gql`
  query {
    allCountries {
      country_id
      name
    }
  }
`
const GET_STATES_FOR_COUNTRY = gql`
  query getStatesByCountryId($countryId: Int!) {
    allStatesByCountryId(country_id: $countryId) {
      name
      zone_id
    }
  }
`

const GET_STATE_DETAILS_BY_PINCODE = gql`
  query GetStateDetailsByPincode($pincode: String) {
    getStateDetailsByPincode(pincode: $pincode) {
      pincode
      taluk
      districtname
      statename
    }
  }
`

const GET_GST_INFO = gql`
  query getGstDetails($gstNumber: String!) {
    getGstDetails(gstNumber: $gstNumber) {
      status
      panNumber
      companyName
      address
      pinCode
    }
  }
`

const GET_SAP_DETAILS = gql`
  query GetSapDetails($directCustomerSapCode: String) {
    getSapDetails(directCustomerSAPCode: $directCustomerSapCode) {
      customer_name
      pan_number
      email_address
      gstin_number
      payment_term
      posting_blk
      city
      street5
      customer_no
      cust_group3
      cust_group4
      distribution_channel
      street_house_number
      street2
      district
      street3
      town
      street4
      shipping_plant1
      shipping_plant2
      customer_group1
      postal_code
      region_descr
      lst_number
      tax_code
      bank_key
      tax_description
      sales_office
      sales_group
      sales_dist
      sales_dist_desc
      phone_number1
      phone_number2
      customer_group
      dealer_type
      appointment_date
      reappointment_date
      conversion_date
      credit_ctrl_area
      itr_compliance
      risk_category
      pan_aadhar_link
      recovery_status
      club_type
      club_type_desc
      region_code
      order_blk
      billing_blk
      delivery_blk
      payment_blk
      attribute1
      attribute2
      route_plan
      route_plan_desc
      tcs_jtc1
      sales_organization
      reconciliation_account
      attribute4
      owner_name
      owner_address
      parent_customer
      parent_customer_name
      customer_plant
      valid_resale_certificate
      certificate_type
      certificate_number
      certificate_valid_from
      certificate_valid_to
      vat_registration_number
    }
  }
`

const GET_CHANNEL_PARTNER_DETAILS = gql`
  query getChannelPartnerDetails($id: ID) {
    getChannelPartnerDetails(id: $id) {
      id
      channel_partner_name
      channel_partner_type
      channel_partner_sap_code
    }
  }
`

const GET_ZM_KAM_SM_CSM_DETAILS = gql`
  query GetAdminUserDetailsByRole($roleName: [String]) {
    getAdminUserDetailsByRole(roleName: $roleName) {
      id
      role
      username
    }
  }
`

const GET_DROPDOWN_DETAILS = gql`
  query Query {
    getDropDownDetail
  }
`

const roleNames = [
  'Key Account Manager(KAM)',
  'Service Manager',
  'State Manager(SM)',
  'Sales Head',
  'Cluster Head',
  'State Head',
  'City Manager',
  'Territory Manager',
  'Operations Manager',
  'Customer Success Manager',
  'Zonal Manager(ZM)'
]

const ZONE_OPTIONS = [
  {
    value: 'North',
    label: 'North'
  },
  {
    value: 'South',
    label: 'South'
  },
  {
    value: 'Central/East',
    label: 'Central/East'
  },
  {
    value: 'West',
    label: 'West'
  }
]
const SOLUTION_TYPES = [
  {
    value: 'API',
    label: 'API'
  },
  {
    value: 'PORTAL',
    label: 'PORTAL'
  }
]
const TYPE_OF_CLIENT = [
  {
    value: 'REAL',
    label: 'COMMERCIAL'
  },
  {
    value: 'DEMO',
    label: 'NON-COMMERCIAL'
  }
]

const CUSTOMER_TYPES = [
  {
    value: 'Paid',
    label: 'Paid'
  },
  {
    value: 'POC',
    label: 'POC'
  },
  {
    value: 'R&D',
    label: 'R&D'
  },
  {
    value: 'Demo',
    label: 'Demo'
  },
  {
    value: 'Closed',
    label: 'Closed'
  }
]
const BILLING_MODES = [
  {
    value: 1,
    label: 'PREPAID'
  },
  {
    value: 2,
    label: 'POSTPAID'
  }
]

const CUSTOMER_LOCATIONS = [
  {
    value: 'India',
    label: 'India'
  },
  {
    value: 'International',
    label: 'International'
  }
]

const CUSTOMER_ACQUISITION_TYPES = [
  {
    value: 'Direct Customer',
    label: 'Direct Customer'
  },
  {
    value: 'Indirect Customer',
    label: 'Indirect Customer'
  }
]

const CHANNEL_PARTNER_OPTIONS = []

const DIRECT_CUSTOMER_TYPE_OPTIONS = [
  {
    value: 'Fleet',
    label: 'Fleet'
  },
  {
    value: 'Mining Customer',
    label: 'Mining Customer'
  },
  {
    value: 'Construction Customer',
    label: 'Construction Customer'
  },
  {
    value: 'Enterprise Customer',
    label: 'Enterprise Customer'
  }
]

const INDIRECT_CUSTOMER_TYPE_OPTIONS = [
  {
    value: 'System Integrator',
    label: 'System Integrator'
  },
  {
    value: 'Telematics Dealer',
    label: 'Telematics Dealer'
  },
  {
    value: 'Non Tyre Dealer',
    label: 'Non Tyre Dealer'
  },
  {
    value: 'CEAT Tyre Dealer',
    label: 'CEAT Tyre Dealer'
  },
  {
    value: 'Non CEAT Tyre Dealer',
    label: 'Non CEAT Tyre Dealer'
  },
  {
    value: 'Agent',
    label: 'Agent'
  }
]

const PORTAL_MODES = [
  { label: 'Taabi Pro', value: 'taabi_pro' },
  { label: 'Taabi GPS Lite', value: 'taabi_gps_lite' }
]

const VIDEO_TELEMATICS_TYPE = [
  { label: 'LightMetrics', value: 'lightMetrics' },
  { label: 'LocoNav', value: 'loconav' },
  { label: 'MettaX', value: 'mettax' }
]
class EditCustomer extends Component {
  constructor(props) {
    super(props)
    this.loginId = parseInt(this.props.match.params.loginId, 10)
    let timezoneLists = require('timezone-list').getTimezones()
    const timezoneList = timezoneLists.map(timezone => ({
      value: timezone,
      label: timezone
    }))

    this.state = {
      clientId: '',
      companyName: '',
      username: '',
      person: '',
      password: '',
      clientType: '',
      registrationType: '',
      email: '',
      secondaryEmail: '',
      phoneno: '',
      secondaryContactNumber: '',
      address: '',
      // billingAddress2: '',
      city: '',
      state: '',
      shippingAddress: '',
      shippingCity: '',
      shippingPincode: '',
      country: '',
      shippingCountry: '',
      shippingState: '',
      pincode: '',
      pan: '',
      gst: '',
      isGstEdited: false,
      isGstInfoAvailable: true,
      // plan: null,
      timezoneList: timezoneList,
      timezone: '',
      isEmailValid: true,
      isEmailValid2: true,
      isPhonenoValid: true,
      isPhonenoValid2: true,
      isContactpValid2: true,
      isAddressValid: true,
      isShippingAddressValid: true,
      isCityValid: true,
      isShippingCityValid: true,
      isContactpValid1: true,
      isPhonenoValid1: true,
      isEmailExists: 'false',
      isPhoneExists: 'false',
      isChecked: false,
      isPinValid: true,
      isPanValid: true,
      isGSTValid: true,
      isUsernameValid: true,
      isNameValid: true,
      isSecondaryLandlineNumberValid: true,
      secondaryLandlineNumberError: '',
      customerType: '',
      isContactpValid: true,
      isContactSValid: true,
      isPasswordValid: true,
      isUsernameUnique: true,
      isCancelConfDialogOpen: false,
      isSaveConfDialogOpen: false,
      response: false,
      clientLoginId: '',
      clientNameRes: '',
      stateId: '',
      emailRes: '',
      phonenoRes: '',
      usernameRes: '',
      panNoRes: '',
      typeOfClient: 'REAL',
      expiryDateTime: moment().add(1, 'week'),
      solution: '',
      prorata: 0,
      secondaryLandlineNumber: '',
      isSecondaryContact: false,
      isEmailValid1: true,
      selectedServiceType: '',
      minimumTrackedDays: 0,
      packetThreshold: 0,
      billingMode: '',
      salesPerson: '',
      allSalesPerson: [],
      isStateChanged: false,
      // isShippingAddressChecked: false
      isShippingAddressChecked: false,
      isShippingPinvalid: true,
      is_sim_tracking: false,
      gstErrorFieldText: '',
      showFields: false,
      selectedMode: null,
      selectedPlan: null,
      // selectedSolutionMaster: null,
      selectedZM: null,
      selectedStateManager: null,
      selectedTerritoryManager: null,
      selectedSalesHead: null,
      selectedClusterHead: null,
      selectedStateHead: null,
      selectedCityManager: null,
      selectedOperationsManager: null,
      selectedVTM: null,
      selectedKAM: null,
      channelPartnerName: '',
      channelPartnerSAPCode: '',
      totalPotentialVehicles: 0,
      zonalManagers: [],
      stateManagers: [],
      territoryManagers: [],
      salesHeads: [],
      clusterHeads: [],
      stateHeads: [],
      cityManagers: [],
      operationsManagers: [],
      keyAccountManagers: [],
      serviceManagers: [],
      customerSuccessManagers: [],
      indirectCustomerType: '',
      channelPartnerType: '',
      channelPartnerSAPCodeNew: [],
      clientCategory: 'B',
      clientCategoryOptions: [
        { value: 'C', label: 'Committed Customer' },
        { value: 'B', label: 'Basic Customer' }
      ],
      isAdditionalContact: false,
      additionalContactNumbers: '',
      isAdditionalContactValid: true,
      additionalContactError: ''
    }
  }

  handlePincodeChange = event => {
    const enteredPincode = event.target.value
    let isValid

    if (this.state.country === 99) {
      isValid = /^\d{6}$/.test(enteredPincode)
    } else {
      isValid = true
    }

    this.setState({
      pincode: enteredPincode,
      pincodeError: !isValid
    })

    if (isValid) {
      this.getStateAndCityByPin(enteredPincode)
    }
  }

  getStateAndCityByPin = enteredPincode => {
    this.props.client
      .query({
        query: GET_STATE_DETAILS_BY_PINCODE,
        variables: { pincode: enteredPincode }
      })
      .then(response => {
        const { data } = response

        if (data && data.getStateDetailsByPincode) {
          const stateData = data.getStateDetailsByPincode
          const stateName = stateData.statename
          const cityName = stateData.districtname

          // this.setState({
          //   state: stateData.statename,
          //   city: stateData.districtname,
          // });
          this.props.client
            .query({
              query: GET_STATES_FOR_COUNTRY,
              variables: { countryId: Number(this.state.country) || 99 }
            })
            .then(stateResponse => {
              const states = stateResponse.data.allStatesByCountryId
              const selectedState = states.find(
                state => state.name.toLowerCase() === stateName.toLowerCase()
              )

              if (selectedState) {
                this.setState({
                  state: selectedState.zone_id,
                  city: cityName
                  // stateId: selectedState.zone_id,
                })
              } else {
                console.error('State not found in the country list')
              }
            })
            .catch(err => {
              console.error('Error fetching states by country:', err)
            })
        }
      })
      .catch(error => {
        console.error('Error fetching state and city:', error)
      })
  }

  getClients = async () => {
    const { data } = await this.props.client.query({
      query: GET_CLIENT,
      variables: {
        loginId: parseInt(this.loginId, 10)
      },
      fetchPolicy: 'network-only'
    })
    // console.log('clientDetails', data.clientDetail)
    // console.log(data.address)

    this.setDetails(data.clientDetail)
  }

  setZmKamSmCsmValues = async () => {
    const { data } = await this.props.client.query({
      query: GET_CLIENT,
      variables: {
        loginId: parseInt(this.loginId, 10)
      },
      fetchPolicy: 'network-only'
    })

    this.setState({
      selectedSM: this.state.stateManagers.find(
        sm => sm.id === data.clientDetail.stateManager
      )
        ? this.state.stateManagers.find(
            sm => sm.id === data.clientDetail.stateManager
          ).id
        : null,
      selectedZM: this.state.zonalManagers.find(
        zm => zm.id === data.clientDetail.zonalManager
      )
        ? this.state.zonalManagers.find(
            zm => zm.id === data.clientDetail.zonalManager
          ).id
        : null,
      selectedStateManager: this.state.stateManagers.find(
        sm => sm.id === data.clientDetail.stateManager
      )
        ? this.state.stateManagers.find(
            sm => sm.id === data.clientDetail.stateManager
          ).id
        : null,
      selectedKAM: this.state.keyAccountManagers.find(
        kam => kam.id === data.clientDetail.keyAccountManager
      )
        ? this.state.keyAccountManagers.find(
            kam => kam.id === data.clientDetail.keyAccountManager
          ).id
        : null,
      serviceManager: this.state.serviceManagers.find(
        sm => sm.id === data.clientDetail.serviceManager
      )
        ? this.state.serviceManagers.find(
            sm => sm.id === data.clientDetail.serviceManager
          ).id
        : null,
      customerSuccessManager: this.state.customerSuccessManagers.find(
        csm => csm.id === data.clientDetail.customerSuccessManager
      )
        ? this.state.customerSuccessManagers.find(
            csm => csm.id === data.clientDetail.customerSuccessManager
          ).id
        : null
    })
  }

  getChannelPartnerDetailsNew = () => {
    this.props.client
      .query({
        query: GET_CHANNEL_PARTNER_DETAILS
      })
      .then(response => {
        const { data } = response

        if (data && data.getChannelPartnerDetails) {
          console.log(
            'getChannelPartnerDetailsNew fetched:',
            data.getChannelPartnerDetails
          )

          this.setState({
            channelPartnerSAPCodeNew: data.getChannelPartnerDetails
          })
        }
      })
      .catch(error => {
        console.error('Error fetching plans:', error)
      })
  }

  handleDateTimeChange = date =>
    this.setState({ expiryDateTime: date, isStateChanged: true })

  async componentDidMount() {
    try {
      await this.getZmKamSmCsmDetails()
      await this.setZmKamSmCsmValues()
    } catch (error) {
      console.error('Error in getZmKamSmCsmDetails:', error)
    }
    this.getClients()
    this.getAllSalesPersonDetails()
    this.getAllSalesPersonDetails()
    this.fetchDropdownDetails()
    this.getChannelPartnerDetailsNew()
  }

  getZmKamSmCsmDetails = async () => {
    this.props.client
      .query({
        query: GET_ZM_KAM_SM_CSM_DETAILS,
        variables: { roleName: roleNames },
        fetchPolicy: 'network-only'
      })
      .then(response => {
        const zonalManagers = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'Zonal Manager(ZM)'
        )
        const keyAccountManagers = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'Key Account Manager(KAM)'
        )
        const serviceManagers = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'Service Manager'
        )
        const customerSuccessManagers = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'Customer Success Manager'
        )
        const stateManagers = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'State Manager(SM)'
        )
        const territoryManagers = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'Territory Manager'
        )
        const salesHeads = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'Sales Head'
        )
        const clusterHeads = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'Cluster Head'
        )
        const stateHeads = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'State Head'
        )
        const cityManagers = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'City Manager'
        )
        const operationsManagers = response.data.getAdminUserDetailsByRole.filter(
          user => user.role === 'Operations Manager'
        )

        this.setState({
          zonalManagers,
          stateManagers,
          territoryManagers,
          salesHeads,
          clusterHeads,
          stateHeads,
          cityManagers,
          operationsManagers,
          keyAccountManagers,
          serviceManagers,
          customerSuccessManagers
        })
      })
      .catch(error => {
        console.error('Error fetching ZM/KAM/SM/CSM details:', error)
      })
  }

  handleInputChangeIndirectCustomerName = key => e => {
    const { name, value } = e.target
    this.setState({ [name]: value, customerNameToBeDisplayed: value })
  }

  handleProrata = e => {
    this.setState({ [e.target.name]: e.target.value, isStateChanged: true })
  }

  setProrata = e => {
    this.setState({ minimumTrackedDays: 1, packetThreshold: 1 })
  }

  // handleCheckboxChange = e => {
  //   const name = e.target.name

  //   this.setState(prev => ({
  //     // isChecked: !prev.isChecked
  //     prorata: prev ? 0 : 1
  //   }))
  // }

  handleCheckboxChange = e => {
    this.state.prorata
      ? this.setState({ prorata: 0 })
      : this.setState({ prorata: 1 })
  }

  handleSecondaryContactAvailable = e => {
    this.state.isSecondaryContact
      ? this.setState({ isSecondaryContact: false })
      : this.setState({ isSecondaryContact: true })
  }

  handleAdditionalContactAvailable = e => {
    this.state.isAdditionalContact
      ? this.setState({
          isAdditionalContact: false,
          additionalContactNumbers: '',
          isAdditionalContactValid: true,
          additionalContactError: ''
        })
      : this.setState({ isAdditionalContact: true })
  }

  handleAdditionalContactChange = e => {
    const value = e.target.value
    this.setState({
      additionalContactNumbers: value,
      isAdditionalContactValid: true,
      additionalContactError: ''
    })
  }

  checkAdditionalContactValidity = () => {
    const {
      additionalContactNumbers,
      contactNumber,
      secondaryContactNumber
    } = this.state
    if (!additionalContactNumbers.trim()) {
      this.setState({
        isAdditionalContactValid: false,
        additionalContactError: 'Additional contact numbers are required'
      })
      return
    }

    const numbers = additionalContactNumbers.split(',').map(num => num.trim())
    const regex = /^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/

    // Check for invalid format
    const invalidNumbers = numbers.filter(num => !regex.test(num))
    if (invalidNumbers.length > 0) {
      this.setState({
        isAdditionalContactValid: false,
        additionalContactError: `Invalid phone number(s): ${invalidNumbers.join(
          ', '
        )}`
      })
      return
    }

    // Check for duplicates with primary or secondary numbers
    const primaryNumber = contactNumber
      ? contactNumber.replace(/[^0-9]/g, '')
      : ''
    const secondaryNumber = secondaryContactNumber
      ? secondaryContactNumber.replace(/[^0-9]/g, '')
      : ''

    const duplicateNumbers = numbers.filter(num => {
      const cleanNum = num.replace(/[^0-9]/g, '')
      return (
        (primaryNumber && cleanNum === primaryNumber) ||
        (secondaryNumber && cleanNum === secondaryNumber)
      )
    })

    if (duplicateNumbers.length > 0) {
      this.setState({
        isAdditionalContactValid: false,
        additionalContactError: `Cannot use primary/secondary number: ${duplicateNumbers.join(
          ', '
        )}`
      })
    } else {
      this.setState({
        isAdditionalContactValid: true,
        additionalContactError: ''
      })
    }
  }

  handleToggle = () => {
    this.setState(prevState => ({
      showFields: !prevState.showFields
    }))
  }
  handleModeChange = selectedOption => {
    this.setState({ selectedMode: selectedOption })
  }
  handleVideoTelematicsMenuChange = selectedOption => {
    this.setState({ selectedVTM: selectedOption ? selectedOption.value : '' })
  }
  // handleZMChange = selectedOption => {
  //   if (selectedOption) {
  //     this.setState({ selectedZM: selectedOption.value || '' })
  //   } else {
  //     this.setState({ selectedZM: '' })
  //   }
  // }

  handleZMChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ selectedZM: null })
    } else {
      if (
        !this.state.zonalManagers.some(zm => zm.id === selectedOption.value)
      ) {
        this.setState({ selectedZM: null })
      } else {
        this.setState({ selectedZM: selectedOption.value })
      }
    }
  }
  handleStateManagerChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ selectedStateManager: null })
    } else {
      if (
        !this.state.stateManagers.some(sm => sm.id === selectedOption.value)
      ) {
        this.setState({ selectedStateManager: null })
      } else {
        this.setState({ selectedStateManager: selectedOption.value })
      }
    }
  }
  handleTerritoryManagerChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ selectedTerritoryManager: null })
    } else {
      if (
        !this.state.territoryManagers.some(tm => tm.id === selectedOption.value)
      ) {
        console.warn(
          'Selected territory manager not found in territory manager list'
        )
      } else {
        this.setState({ selectedTerritoryManager: selectedOption.value })
      }
    }
  }
  handleSalesHeadChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ selectedSalesHead: null })
    } else {
      if (!this.state.salesHeads.some(sh => sh.id === selectedOption.value)) {
        console.warn('Selected sales head not found in sales head list')
      } else {
        this.setState({ selectedSalesHead: selectedOption.value })
      }
    }
  }
  handleClusterHeadChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ selectedClusterHead: null })
    } else {
      if (!this.state.clusterHeads.some(ch => ch.id === selectedOption.value)) {
        console.warn('Selected cluster head not found in cluster head list')
      } else {
        this.setState({ selectedClusterHead: selectedOption.value })
      }
    }
  }
  handleStateHeadChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ selectedStateHead: null })
    } else {
      if (!this.state.stateHeads.some(sh => sh.id === selectedOption.value)) {
        console.warn('Selected state head not found in state head list')
      } else {
        this.setState({ selectedStateHead: selectedOption.value })
      }
    }
  }
  handleCityManagerChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ selectedCityManager: null })
    } else {
      if (!this.state.cityManagers.some(cm => cm.id === selectedOption.value)) {
        console.warn('Selected city manager not found in city manager list')
      } else {
        this.setState({ selectedCityManager: selectedOption.value })
      }
    }
  }
  handleOperationsManagerChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ selectedOperationsManager: null })
    } else {
      if (
        !this.state.operationsManagers.some(
          om => om.id === selectedOption.value
        )
      ) {
        console.warn(
          'Selected operations manager not found in operations manager list'
        )
      } else {
        this.setState({ selectedOperationsManager: selectedOption.value })
      }
    }
  }
  handleKAMChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ selectedKAM: null })
    } else {
      if (
        !this.state.keyAccountManagers.some(
          kam => kam.id === selectedOption.value
        )
      ) {
        this.setState({ selectedKAM: null })
      } else {
        this.setState({ selectedKAM: selectedOption.value })
      }
    }
  }
  handleSMChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ serviceManager: null })
    } else {
      if (
        !this.state.serviceManagers.some(sm => sm.id === selectedOption.value)
      ) {
        this.setState({ serviceManager: null })
      } else {
        this.setState({ serviceManager: selectedOption.value })
      }
    }
  }
  handleCSMChange = selectedOption => {
    if (!selectedOption || !selectedOption.value) {
      this.setState({ customerSuccessManager: null })
    } else {
      if (
        !this.state.customerSuccessManagers.some(
          csm => csm.id === selectedOption.value
        )
      ) {
        this.setState({ customerSuccessManager: null })
      } else {
        this.setState({ customerSuccessManager: selectedOption.value })
      }
    }
  }

  handleServiceTypeChange = selectedOption => {
    this.setState({
      selectedServiceType: selectedOption ? selectedOption.value : ''
    })
  }

  // handleKAMChange = selectedOption => {
  //   if (selectedOption) {
  //     this.setState({ selectedKAM: selectedOption.value || '' })
  //   } else {
  //     this.setState({ selectedKAM: '' })
  //   }
  // }
  handleChannelPartnerNameChange = event => {
    this.setState({ channelPartnerName: event.target.value })
  }

  functionTakeAndGiveModeValue = input => {
    let value = input && input.value ? input.value : input
    if (value == 'taabi_pro' || value == 'Taabi Pro') {
      return 'Taabi Pro'
    } else if (value == 'Taabi GPS Lite' || value == 'taabi_gps_lite') {
      return 'Taabi GPS Lite'
    } else {
      return 'Taabi GPS Lite'
    }
  }

  functionTakeAndGiveVideoTeleValueInCaps = input => {
    let value = input && input.value ? input.value : input
    console.log('Input Value:', value)

    switch (value) {
      case 'loconav':
      case 'API-Loconav':
        return 'API-Loconav'
      case 'mettax':
      case 'API-Meta':
        return 'API-Meta'
      case 'lightMetrics':
      case 'iFrame-LM':
        return 'iFrame-LM'
      default:
        return null // Return null for unmatched cases.
    }
  }

  setDetails = clientDetail => {
    console.log('clientDetail : ', clientDetail)
    if (clientDetail.channelPartnerName) {
      this.state.showFields = true
    }

    let simTracking = false
    if (clientDetail.is_sim_tracking) {
      simTracking = clientDetail.is_sim_tracking
    }

    this.setState({
      clientId: clientDetail.id,
      companyName: clientDetail.clientName.toUpperCase(),
      username: clientDetail.login.username,
      existingUsername: clientDetail.login.username,
      contactPerson: clientDetail.contactPerson,
      secondaryContactName: clientDetail.secondaryContactName,
      secondaryContactNumber: clientDetail.secondaryContactNumber,
      secondaryEmail: clientDetail.secondaryEmail,
      isAdditionalContact: !!clientDetail.additionalContactNumbers,
      additionalContactNumbers: clientDetail.additionalContactNumbers,
      email: clientDetail.email,
      existingEmail: clientDetail.email,
      clientType: clientDetail.clientType,
      contactNumber: clientDetail.contactNumber,
      existingContactNumber: clientDetail.contactNumber,
      address: clientDetail.address,
      shippingAddress: clientDetail.shippingAddress,
      shippingCity: clientDetail.shippingCity,
      shippingPincode: clientDetail.shippingPincode,
      city: clientDetail.city,
      state: clientDetail.state.zone_id,
      shippingState: clientDetail.shippingState
        ? clientDetail.shippingState.zone_id
        : null,
      country: clientDetail.country.country_id
        ? clientDetail.country.country_id
        : 99,
      shippingCountry: clientDetail.shippingCountry
        ? clientDetail.shippingCountry.country_id
        : null,
      pincode: clientDetail.pincode,
      customerAddress: clientDetail.address,
      pan: clientDetail.panNumber,
      selectedPlan: clientDetail.plan ? clientDetail.plan.id : null,
      // selectedSolutionMaster: clientDetail.solutionId ? clientDetail.solutionId : null,
      // selectedPlan: clientDetail.plan,
      timezone: clientDetail.timezone
        ? clientDetail.timezone
        : { value: 'Asia/Kolkata', label: 'Asia/Kolkata' },
      prorata: clientDetail.prorata,
      minimumTrackedDays: clientDetail.minimumTrackedDays,
      packetThreshold: clientDetail.packetThreshold,
      gst: clientDetail.gst,
      clientLoginId: clientDetail.loginId,
      customerType: clientDetail.registrationType,
      typeOfClient: clientDetail.type,
      expiryDateTime: clientDetail.expiryDate
        ? moment.unix(clientDetail.expiryDate)
        : this.state.expiryDateTime,
      solution: clientDetail.solution,
      billingMode: clientDetail.billingMode.id,
      salesPerson: clientDetail.salesPerson && clientDetail.salesPerson.id,
      // selectedZM: clientDetail.zonalManager,
      // selectedKAM: clientDetail.keyAccountManager,
      selectedZM: this.state.zonalManagers.find(
        zm => zm.id === clientDetail.zonalManager
      )
        ? this.state.zonalManagers.find(
            zm => zm.id === clientDetail.zonalManager
          ).id
        : null,
      selectedStateManager: this.state.stateManagers.find(
        sm => sm.id === clientDetail.stateManager
      )
        ? this.state.stateManagers.find(
            sm => sm.id === clientDetail.stateManager
          ).id
        : null,
      selectedTerritoryManager: this.state.territoryManagers.find(
        tm => tm.id === clientDetail.territoryManager
      )
        ? this.state.territoryManagers.find(
            tm => tm.id === clientDetail.territoryManager
          ).id
        : null,
      selectedSalesHead: this.state.salesHeads.find(
        sh => sh.id === clientDetail.salesHead
      )
        ? this.state.salesHeads.find(sh => sh.id === clientDetail.salesHead).id
        : null,
      selectedClusterHead: this.state.clusterHeads.find(
        ch => ch.id === clientDetail.clusterHead
      )
        ? this.state.clusterHeads.find(ch => ch.id === clientDetail.clusterHead)
            .id
        : null,
      selectedStateHead: this.state.stateHeads.find(
        sh => sh.id === clientDetail.stateHead
      )
        ? this.state.stateHeads.find(sh => sh.id === clientDetail.stateHead).id
        : null,
      selectedCityManager: this.state.cityManagers.find(
        cm => cm.id === clientDetail.cityManager
      )
        ? this.state.cityManagers.find(cm => cm.id === clientDetail.cityManager)
            .id
        : null,
      selectedOperationsManager: this.state.operationsManagers.find(
        om => om.id === clientDetail.operationsManager
      )
        ? this.state.operationsManagers.find(
            om => om.id === clientDetail.operationsManager
          ).id
        : null,
      selectedKAM: this.state.keyAccountManagers.find(
        kam => kam.id === clientDetail.keyAccountManager
      )
        ? this.state.keyAccountManagers.find(
            kam => kam.id === clientDetail.keyAccountManager
          ).id
        : null,
      channelPartnerName: clientDetail.channelPartnerName,
      selectedVTM: clientDetail.videoTelematicsType,
      selectedServiceType: clientDetail.serviceType
        ? clientDetail.serviceType.toLowerCase()
        : clientDetail.solution
          ? clientDetail.solution.toLowerCase()
          : 'portal',
      selectedMode: clientDetail.litemode
        ? this.functionTakeAndGiveModeValue(clientDetail.litemode)
        : 'taabi_pro',
      is_sim_tracking: simTracking,
      totalPotentialVehicles: clientDetail.totalPotentialVehicles,
      customerAcquisitionType: clientDetail.customerAcquisitionType || null,
      directCustomer: clientDetail.directCustomer
        ? {
            label: clientDetail.directCustomer,
            value: clientDetail.directCustomerSAPCode
          }
        : null,
      directCustomerType: clientDetail.directCustomerType || null,
      directCustomerSAPCode: clientDetail.directCustomerSAPCode || null,
      existingDirectCustomerSAPCode: clientDetail.directCustomerSAPCode || null,
      indirectCustomerType: clientDetail.indirectCustomerType || null,
      channelPartnerType: clientDetail.channelPartnerType || null,
      indirectCustomerName: clientDetail.indirectCustomerName || null,
      indirectCustomerUniqueId: clientDetail.indirectCustomerUniqueId || null,
      customerLocation: clientDetail.customerLocation
        ? clientDetail.customerLocation
        : 'India' || null,
      secondaryLandlineNumber: clientDetail.secondaryLandlineNumber || null,
      channelPartnerSAPCode: clientDetail.channelPartnerSAPCode || null,
      customerNameToBeDisplayed: clientDetail.customerNameToBeDisplayed || null,
      existingCustomerNameToBeDisplayed:
        clientDetail.customerNameToBeDisplayed || null,
      zone: clientDetail.zone || null,
      // serviceManager: clientDetail.serviceManager || null,
      // customerSuccessManager: clientDetail.customerSuccessManager || null,
      serviceManager: this.state.serviceManagers.find(
        sm => sm.id === clientDetail.serviceManager
      )
        ? this.state.serviceManagers.find(
            sm => sm.id === clientDetail.serviceManager
          ).id
        : null,
      customerSuccessManager: this.state.customerSuccessManagers.find(
        csm => csm.id === clientDetail.customerSuccessManager
      )
        ? this.state.customerSuccessManagers.find(
            csm => csm.id === clientDetail.customerSuccessManager
          ).id
        : null,
      isSecondaryContact:
        clientDetail.isSecondaryContact ||
        !!clientDetail.secondaryContactPerson,
      videoTelematicsType:
        this.functionTakeAndGiveVideoTeleValueInCaps(
          clientDetail.videoTelematicsType
        ) || null,
      clientCategory: clientDetail.clientCategory || 'B'
    })
  }

  handleSolutionChange = solutionType => {
    this.setState({
      isStateChanged: true
    })
    console.log('solution:', solutionType)
    if (!solutionType) {
      this.setState({ solution: '' })
    } else {
      this.setState({ solution: solutionType.value })
    }
  }

  hanldeBillingModeChange = billingMode => {
    this.setState({
      isStateChanged: true
    })
    console.log('biiling Mode', billingMode)
    if (!billingMode) {
      this.setState({ billingMode: '' })
    } else {
      this.setState({ billingMode: billingMode.value })
    }
  }

  getAllSalesPersonDetails = async () => {
    const fetchSalesPersonData = await this.props.client.query({
      query: GET_ALL_SALESPERSON,
      variables: {
        partnerLoginId: getLoginId()
      }
    })
    const {
      data: { getAllSalesPerson }
    } = fetchSalesPersonData
    const salesPersonsDetails = getAllSalesPerson.map(salesPerson => ({
      value: salesPerson.id,
      label: salesPerson.name
    }))
    // console.log('Edit customer getAllsataperson :', salesPersonsDetails)
    this.setState({ allSalesPerson: salesPersonsDetails })
  }

  handleSalesPersonChange = salesPerson => {
    this.setState({
      isStateChanged: true
    })
    console.log('salesPerson', salesPerson)
    if (!salesPerson) {
      this.setState({ salesPerson: '' })
    } else {
      this.setState({ salesPerson: salesPerson.value })
    }
  }

  handleInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
      isStateChanged: true
    })
  }

  handleInputChangeNew = key => e => {
    const { name, value } = e.target
    this.setState({ [name]: value })
    if (key === 'indirectCustomerName') {
      this.setState({ customerNameToBeDisplayed: value })
    }
  }

  handleInputChangeUsernamePassword = e => {
    // regex removed (unused)
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSimTracking = e => {
    this.state.is_sim_tracking
      ? this.setState({ is_sim_tracking: false })
      : this.setState({ is_sim_tracking: true })
  }

  // handleCheckboxChange = e => {
  //   const name = e.target.name

  //   this.setState(prev => ({
  //     isChecked: !prev.isChecked
  //   }))
  // }
  handleCountryChange = country => {
    this.setState({
      isStateChanged: true
    })
    if (!country) {
      this.setState({ state: '', country: '' })
    } else {
      this.setState({
        state: '',
        country: country.value
      })
    }
  }

  handleShippingCountryChange = country => {
    this.setState({
      isStateChanged: true
    })
    if (!country) {
      this.setState({ shippingState: '', shippingCountry: '' })
    } else {
      this.setState({ shippingState: '', shippingCountry: country.value })
    }
  }

  handleStateChange = state => {
    // console.log(state, 'state')
    this.setState({
      isStateChanged: true
    })
    this.setState({ state: state && state.value })
  }

  handleShippingStateChange = state => {
    // console.log(state, 'state')
    this.setState({
      isStateChanged: true
    })
    this.setState({ shippingState: state && state.value })
  }

  handlePlanChange = selectedOption => {
    this.setState({
      isStateChanged: true,
      // selectedPlan: selectedOption,
      selectedPlan: selectedOption ? selectedOption.value : null
    })
    // if (!plan) {
    //   this.setState({ plan: '' })
    // } else {
    //   this.setState({ plan: plan.value })
    // }
  }
  // handleSolutionMasterChange = selectedOption => {
  //   this.setState({
  //     isStateChanged: true,
  //     selectedSolutionMaster: selectedOption ? selectedOption.value : null
  //   });
  // };

  handleTimezoneChange = timezone => {
    this.setState({
      isStateChanged: true
    })
    if (!timezone) {
      this.setState({ timezone: '' })
    } else {
      this.setState({ timezone: timezone.value })
    }
  }

  // handleCustomerTypeChange = customer => {
  //   console.log('Customer', customer)
  //   if (!customer) {
  //     this.setState({ registrationType: '' })
  //   } else {
  //     this.setState({
  //       registrationType: customer.value,
  //       gst: '',
  //       pan: '',
  //       companyName: '',
  //       address: '',
  //       pincode: ''
  //     })
  //   }
  // }

  handleCustomerTypeChange = customer => {
    // console.log('Customer', customer)
    if (!customer) {
      this.setState({ customerType: '' })
    } else {
      this.setState({
        customerType: customer.value,
        isGSTExists: null,
        isGSTValid: true,
        gst: '',
        panNumber: '',
        address: '',
        pincode: '',
        gstCompanyName: '',
        clientNameRes: '',
        isNameValid: true,
        isAddressValid: true,
        isPinValid: true
      })
    }
  }

  handleCustomerAcquisitionTypeChange = customer => {
    this.setState({ customerAcquisitionType: customer ? customer.value : '' })

    if (this.state.customerAcquisitionType === 'Direct Customer') {
      this.setState({
        indirectCustomerType: null,
        indirectCustomerName: null,
        channelPartnerName: null,
        channelPartnerSAPCode: null,
        channelPartnerType: null
      })
    } else if (this.state.customerAcquisitionType === 'Indirect Customer') {
      this.setState({
        directCustomerType: null,
        directCustomer: null,
        directCustomerSAPCode: null
      })
    }
  }

  //   checkNameValidity = client => async event => {
  //     console.log("inside checkName");
  //     const { customerNameToBeDisplayed } = this.state;

  //     const regex = new RegExp(
  //       /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,100}$/
  //     );

  //     const isValidFormat = regex.test(customerNameToBeDisplayed) && customerNameToBeDisplayed !== '';

  //     let isNameAvailable = false;
  //     try {
  //       const { data } = await client.query({
  //         query: GET_CLIENT_NAME,
  //         variables: { clientName: customerNameToBeDisplayed }
  //       });

  //       isNameAvailable = data.checkClientName === 'AVAILABLE';
  //     } catch (error) {
  //       console.error('Error checking name availability', error);
  //       isNameAvailable = false;
  //     }

  //     console.log("isValidFormat && isNameAvailable :", isValidFormat && isNameAvailable);

  //     this.setState({
  //       isNameValid: isValidFormat && isNameAvailable,
  //       clientNameRes: customerNameToBeDisplayed.length === 0
  //         ? 'Please enter the name'
  //         : !isValidFormat
  //         ? 'Name can be characters or Number between 5-32 characters'
  //         : !isNameAvailable
  //         ? 'Name already exists'
  //         : ''
  //     });
  // }
  checkNameValidity = client => async event => {
    const name =
      this.state.customerAcquisitionType === 'Direct Customer'
        ? this.state.customerNameToBeDisplayed ||
          (this.state.directCustomer ? this.state.directCustomer.label : '')
        : this.state.customerAcquisitionType === 'Indirect Customer'
          ? this.state.customerNameToBeDisplayed ||
            this.state.indirectCustomerName
          : this.state.customerNameToBeDisplayed || ''

    if (
      name.toLowerCase() ===
      this.state.existingCustomerNameToBeDisplayed.toLowerCase()
    ) {
      this.setState({
        isNameValid: true,
        clientNameRes: ''
      })
      return
    }

    const regex = new RegExp(
      // /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,100}$/
      /^(?!\s)(?!.*\s$).{5,100}$/
    )

    const isValidFormat = regex.test(name) && name !== ''
    let isNameAvailable = false

    try {
      const { data } = await client.query({
        query: GET_CLIENT_NAME,
        variables: { businessname: name }
      })

      isNameAvailable = data.checkClientName === 'AVAILABLE'
    } catch (error) {
      console.error('Error checking name availability', error)
      isNameAvailable = false
    }

    console.log(
      'isValidFormat && isNameAvailable :',
      isValidFormat && isNameAvailable
    )

    this.setState({
      isNameValid: isValidFormat && isNameAvailable,
      clientNameRes:
        name.length === 0
          ? 'Please enter the name'
          : !isValidFormat
            ? 'Name must be at least 5 characters not contain spaces at beginning or end'
            : !isNameAvailable
              ? 'Name already exists'
              : ''
    })
  }

  checkUsernameValidity = client => async event => {
    if (this.state.username === this.state.existingUsername) {
      this.setState({
        usernameRes: '',
        isUsernameValid: true
      })
      return
    }
    const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{5,32}$/)
    const { data } = await client.query({
      query: GET_USERNAME,
      variables: { username: this.state.username }
    })

    this.setState({
      isUsernameUnique: data.checkUsername === 'AVAILABLE',
      isUsernameValid:
        regex.test(this.state.username) &&
        this.state.username !== '' &&
        data.checkUsername === 'AVAILABLE'
    })

    if (regex.test(this.state.username) === false) {
      this.setState({
        usernameRes:
          'Username Can be character number special chatcters(-_$@*!) without blank space between 5-32 charcters',
        isUsernameValid: false
      })
    } else if (data.checkUsername !== 'AVAILABLE') {
      this.setState({
        usernameRes: 'Username already exist',
        isUsernameValid: false
      })
    }
  }

  checkContactpValidity = () => {
    const regex = new RegExp(/^[a-zA-Z\s]{3,32}$/)

    this.setState({
      isContactpValid1: regex.test(this.state.contactPerson)
    })
  }

  checkContactpValidityTwo = () => {
    const regex = new RegExp(/^[a-zA-Z\s]{3,32}$/)

    this.setState({
      isContactpValid2: regex.test(this.state.secondaryContactName)
    })
  }

  checkPasswordValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!#]{3,20}$/)
    const regex = new RegExp(/^[a-zA-Z0-9!@#$&()\\-`.+,/"]{3,20}$/)
    this.setState({
      isPasswordValid:
        this.state.password !== '' && regex.test(this.state.password)
    })
  }

  checkPhonenoValidity1 = client => async event => {
    if (this.state.contactNumber !== this.state.existingContactNumber) {
      const regex = new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/)

      const { data } = await client.query({
        query: GET_CONTACTNO,
        variables: { phoneno: this.state.contactNumber }
      })

      this.setState({
        isPhoneExists: data.checkClientContactNumber === 'AVAILABLE',
        isPhonenoValid1: regex.test(this.state.contactNumber)
      })
      if (this.state.contactNumber === this.state.secondaryContactNumber) {
        this.setState({
          phonenoRes2:
            'Secondary Contact Number should not be the same as Primary Contact Number',
          isPhonenoValid2: false
        })
      }
    }
  }

  checkPhonenoValidity2 = client => async event => {
    const regex = new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/)

    if (this.state.secondaryContactNumber !== '') {
      this.setState({
        isPhonenoValid2: regex.test(this.state.secondaryContactNumber)
      })

      if (regex.test(this.state.secondaryContactNumber) === false) {
        this.setState({ phonenoRes2: 'Invalid phone number' })
      }

      if (this.state.secondaryContactNumber === this.state.contactNumber) {
        this.setState({
          phonenoRes2:
            'Secondary Contact Number should not be the same as Primary Contact Number',
          isPhonenoValid2: false
        })
      }
    } else {
      this.setState({
        phonenoRes2: 'Invalid phone number',
        isPhonenoValid2: false
      })
    }
  }

  checkLandlineValidity = async (event, fieldName) => {
    this.setState({ [`${fieldName}Error`]: '' })
    const regex = new RegExp(/^\(?\d{3,4}\)?[-\s]?\d{6,8}$/)

    const landlineNumber = this.state[fieldName]

    if (landlineNumber) {
      const isValid = regex.test(landlineNumber)
      this.setState({
        [`${fieldName}Valid`]: isValid
      })

      if (!isValid && landlineNumber) {
        this.setState({ [`${fieldName}Error`]: 'Invalid landline number' })
      } else {
        this.setState({ [`${fieldName}Error`]: '' })
      }
    }
  }

  checkEmailValidity1 = client => async event => {
    if (this.state.email !== this.state.existingEmail) {
      const regex = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      const { data } = await client.query({
        query: GET_EMAIL,
        variables: { email: this.state.email }
      })
      this.setState({
        isEmailExists: data.checkClientEmail === 'AVAILABLE',
        isEmailValid1: regex.test(this.state.email)
      })
      if (this.state.email === this.state.secondaryEmail) {
        this.setState({
          emailRes2: 'Secondary Email should not be the same as Primary Email',
          isEmailValid2: false
        })
      }
    }
  }

  checkEmailValidity2 = client => async event => {
    const regex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    if (this.state.secondaryEmail !== '') {
      this.setState({
        isEmailValid2: regex.test(this.state.secondaryEmail)
      })
      if (regex.test(this.state.secondaryEmail) === false) {
        this.setState({ emailRes2: 'Invalid Email' })
      }

      if (this.state.secondaryEmail === this.state.email) {
        this.setState({
          emailRes2: 'Secondary Email should not be the same as Primary Email',
          isEmailValid2: false
        })
      }
    } else {
      this.setState({
        emailRes2: 'Invalid email',
        isEmailValid2: false
      })
    }
  }
  checkAddressValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)

    const regex = new RegExp(/^(.{5,200})$/)
    const regex2 = new RegExp(/^[^\s]+(\s+[^\s]+)*$/)
    this.setState({
      isAddressValid:
        regex.test(this.state.address) && regex2.test(this.state.address)
    })
  }

  checkShippingAddressValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)

    const regex = new RegExp(/^(.{5,200})$/)
    const regex2 = new RegExp(/^[^\s]+(\s+[^\s]+)*$/)
    this.setState({
      isShippingAddressValid:
        regex.test(this.state.shippingAddress) &&
        regex2.test(this.state.shippingAddress)
    })
  }

  checkCountryValidity = () => {
    this.setState({
      isCountryValid: this.state.country !== ''
    })
  }

  checkCountryValidity2 = () => {
    this.setState({
      isCountryValid: this.state.shippingCountry !== ''
    })
  }

  checkCityValidity = arg => {
    const regex = new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/)

    if (arg === 'billing') {
      this.setState({
        isCityValid: regex.test(this.state.city) && this.state.city !== ''
      })
    } else if (arg === 'shipping') {
      this.setState({
        isShippingCityValid:
          regex.test(this.state.shippingCity) && this.state.city !== ''
      })
    }
  }

  checkPinValidity = () => {
    this.setState({ isPinValid: true })
    if (this.state.pincode !== null && this.state.pincode !== '') {
      const regex = new RegExp(/^[1-9][0-9]{5}$/)
      this.setState({
        isPinValid: regex.test(this.state.pincode)
      })
    }
  }
  checkPinValidity2 = () => {
    this.setState({ isShippingPinvalid: true })
    if (
      this.state.shippingPincode !== null &&
      this.state.shippingPincode !== ''
    ) {
      const regex = new RegExp(/^[1-9][0-9]{5}$/)
      this.setState({
        isShippingPinvalid: regex.test(this.state.shippingPincode)
      })
    }
  }

  checkPanValidity = client => async event => {
    // console.log(this.state.pan, 'pan')
    this.setState({ panNoRes: '' })
    if (this.state.pan !== null && this.state.pan !== '') {
      const regex = new RegExp(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/)
      const { data } = await client.query({
        query: GET_PAN_NUMBER,
        variables: { pan: this.state.pan }
      })

      this.setState({
        isPanValid: regex.test(this.state.pan),
        isPanExists: data.checkClientPanNumber === 'AVAILABLE'
      })
    }
  }

  checkGSTValidity = async gstNumber => {
    if (this.state.gst !== null && this.state.gst !== '') {
      // const regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9]{1}Z[a-zA-Z0-9]{1}$/)
      const regex = new RegExp(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
      )
      const { data } = await this.props.client.query({
        query: GET_GST_NUMBER,
        variables: { gst: this.state.gst },
        fetchPolicy: 'network-only'
      })

      this.setState({
        isGSTExists: data.checkClientGST === 'AVAILABLE',
        isGSTValid: regex.test(this.state.gst)
      })

      if (!this.state.isGSTValid) {
        this.setState({
          gstErrorFieldText: 'Invalid GST Number.'
        })
      }

      if (this.state.isGSTExists === false) {
        this.setState({ gstErrorFieldText: 'GST Number already registered.' })
      }

      if (this.state.isGSTValid && this.state.isGSTExists) {
        this.setState({
          gstErrorFieldText: '',
          panNumber: '',
          gstCompanyName: '',
          address: '',
          pincode: ''
        })

        await this.getGstInfo(gstNumber)
        if (!this.state.isGstInfoAvailable) {
          this.setState({ gstErrorFieldText: 'Invalid GST Number.' })
        }
      } else {
        this.setState({
          panNumber: '',
          gstCompanyName: '',
          address: '',
          pincode: ''
        })
      }
    } else {
      this.setState({
        panNumber: '',
        gstCompanyName: '',
        address: '',
        pincode: ''
      })
    }
  }

  handleCancelClick = e => {
    if (this.state.isStateChanged) {
      this.setState({ isCancelConfDialogOpen: true })
    } else {
      this.cancelForm()
    }
  }

  handleSaveClick = e => {
    this.setState({ isSaveConfDialogOpen: true })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleSaveNegativeResponse = e => {
    this.setState({ isSaveConfDialogOpen: false })
  }

  handleShippingAddressCheckbox = () => {
    this.setState({
      isShippingAddressValid: true,
      isShippingCityValid: true,
      isShippingPinvalid: true,
      shippingAddress: '',
      shippingCity: '',
      shippingPincode: '',
      shippingCountry: '',
      shippingState: ''
    })
    this.setState(
      {
        isShippingAddressChecked: !this.state.isShippingAddressChecked
      },
      () => {
        if (this.state.isShippingAddressChecked === true) {
          this.setState({
            shippingAddress: this.state.address,
            shippingCity: this.state.city,
            shippingPincode: this.state.pincode,
            shippingCountry: this.state.country,
            shippingState: this.state.state
          })
        } else {
          this.setState({
            shippingAddress: '',
            shippingCity: '',
            shippingPincode: '',
            shippingCountry: '',
            shippingState: ''
          })
        }
      }
    )
  }

  fetchDropdownDetails = async () => {
    try {
      const response = await this.props.client.query({
        query: GET_DROPDOWN_DETAILS
      })

      const dropDownData = JSON.parse(response.data.getDropDownDetail)
      const dropdownValues = {}

      Object.keys(dropDownData).forEach(key => {
        if (Array.isArray(dropDownData[key])) {
          dropdownValues[key] = dropDownData[key].filter(
            option => option !== null
          )
        }
      })

      // Map state manager strings (if present) into objects for Select options
      const dropdownStateManagers = dropdownValues.statemanager
        ? dropdownValues.statemanager.map(sm => ({ label: sm, value: sm }))
        : []

      // Do not overwrite stateManagers fetched from admin API (getZmKamSmCsmDetails)
      const mergedStateManagers =
        this.state.stateManagers && this.state.stateManagers.length
          ? this.state.stateManagers
          : dropdownStateManagers

      this.setState({
        ...dropdownValues,
        stateManagers: mergedStateManagers
      })
    } catch (error) {
      console.error('Error fetching dropdown details:', error)
    }
  }
  submitForm = client => async e => {
    e.preventDefault()
    let zonalManager = this.state.selectedZM || ''
    // let litemode =  this.state.selectedMode && this.state.selectedMode.value ? convertToSnakeCase(this.state.selectedMode.value) : ''
    let litemode = this.state.selectedMode
      ? this.state.selectedMode.value
        ? convertToSnakeCase(this.state.selectedMode.value)
        : convertToSnakeCase(this.state.selectedMode)
      : ''
    console.log('litemode: ', litemode)
    // let videoTelematicsType = this.state.selectedVTM && this.state.selectedVTM.value ? functionTakeAndGiveVideoTeleValue(this.state.selectedVTM.value) : null
    let keyAccountManager = this.state.selectedKAM || ''
    let channelPartnerName = this.state.channelPartnerName || ''
    console.log(
      'serviceType: ',
      this.state.selectedServiceType && this.state.selectedServiceType.value
        ? this.state.selectedServiceType.value
        : this.state.selectedServiceType.label
          ? this.state.selectedServiceType.label
          : ''
    )
    // let serviceType = this.state.selectedServiceType &&  this.state.selectedServiceType.value ? this.state.selectedServiceType.value : this.state.selectedServiceType.label ? this.state.selectedServiceType.label : ''
    // console.log('videoTelematicsType : ',videoTelematicsType,serviceType);
    let variables = {
      id: parseInt(this.state.clientId, 10),
      clientName:
        this.state.customerNameToBeDisplayed ||
        (this.state.customerAcquisitionType === 'Direct Customer' &&
        this.state.directCustomer
          ? this.state.directCustomer.label
          : this.state.customerAcquisitionType === 'Indirect Customer'
            ? this.state.indirectCustomerName
            : null),
      login_id: parseInt(this.loginId, 10),
      email: this.state.email,
      contactPerson: this.state.contactPerson,
      contactNumber: this.state.contactNumber,
      secondaryEmail: this.state.isSecondaryContact
        ? this.state.secondaryEmail
        : null,
      secondaryContactName: this.state.isSecondaryContact
        ? this.state.secondaryContactName
        : null,
      secondaryContactNumber: this.state.isSecondaryContact
        ? this.state.secondaryContactNumber
        : null,
      address: this.state.customerAddress || this.state.address,
      shippingAddress: this.state.shippingAddress,
      shippingCountry: this.state.shippingCountry,
      shippingState: this.state.shippingState,
      shippingCity: this.state.shippingCity,
      shippingPincode: parseInt(this.state.shippingPincode, 10),
      city: this.state.city,
      state_id: parseInt(this.state.state, 10),
      state: parseInt(this.state.state, 10),
      country_id: parseInt(this.state.country, 10),
      pincode: parseInt(this.state.pincode, 10),
      panNumber: this.state.pan,
      clientType: this.state.clientType,
      customerType: this.state.customerType,
      subscriptionPlan: 'prepaid',
      periodicity: 1,
      status: 1,
      partnerLoginId: getLoginId(),
      plan: parseInt(this.state.selectedPlan, 10),
      // solutionId: this.state.selectedSolutionMaster,
      timezone: this.state.timezone,
      gst: this.state.gst,
      username: this.state.username,
      typeOfClient: this.state.typeOfClient,
      solution: this.state.solution,
      billingMode: this.state.billingMode,
      prorata: this.state.prorata,
      packetThreshold: parseInt(this.state.packetThreshold, 10),
      salesPersonId: this.state.salesPerson,
      minimumTrackedDays: parseInt(this.state.minimumTrackedDays, 10),
      zonalManager: zonalManager,
      stateManager: this.state.selectedStateManager || '',
      territoryManager: this.state.selectedTerritoryManager || null,
      salesHead: this.state.selectedSalesHead || null,
      clusterHead: this.state.selectedClusterHead || null,
      stateHead: this.state.selectedStateHead || null,
      cityManager: this.state.selectedCityManager || null,
      operationsManager: this.state.selectedOperationsManager || null,
      litemode: litemode,
      // videoTelematicsType: videoTelematicsType|| null,
      videoTelematicsType:
        this.state.selectedVTM === 'none' ? null : this.state.selectedVTM,
      keyAccountManager: keyAccountManager,
      channelPartnerName:
        this.state.customerAcquisitionType === 'Indirect Customer'
          ? channelPartnerName
          : null,
      is_sim_tracking: this.state.is_sim_tracking,
      isSecondaryContact: this.state.isSecondaryContact || false,
      totalPotentialVehicles: parseInt(this.state.totalPotentialVehicles, 10),
      customerAcquisitionType: this.state.customerAcquisitionType || null,

      directCustomer:
        this.state.customerAcquisitionType === 'Direct Customer'
          ? this.state.directCustomer
            ? this.state.directCustomer.label
            : null
          : null,
      directCustomerType:
        this.state.customerAcquisitionType === 'Direct Customer'
          ? this.state.directCustomerType
          : null,
      directCustomerSAPCode:
        this.state.customerAcquisitionType === 'Direct Customer'
          ? this.state.directCustomerSAPCode
          : null,
      indirectCustomerType:
        this.state.customerAcquisitionType === 'Indirect Customer'
          ? this.state.indirectCustomerType
          : null,
      channelPartnerType:
        this.state.customerAcquisitionType === 'Indirect Customer'
          ? this.state.channelPartnerType
          : null,
      indirectCustomerName:
        this.state.customerAcquisitionType === 'Indirect Customer'
          ? this.state.indirectCustomerName
          : null,
      indirectCustomerUniqueId:
        this.state.customerAcquisitionType === 'Indirect Customer'
          ? this.state.indirectCustomerUniqueId
          : null,
      customerLocation: this.state.customerLocation || null,
      secondaryLandlineNumber: this.state.isSecondaryContact
        ? this.state.secondaryLandlineNumber
        : null,
      channelPartnerSAPCode:
        this.state.customerAcquisitionType === 'Indirect Customer'
          ? this.state.channelPartnerSAPCode
          : null,
      customerNameToBeDisplayed:
        this.state.customerNameToBeDisplayed ||
        (this.state.customerAcquisitionType == 'Direct Customer' &&
        this.state.directCustomer
          ? this.state.directCustomer.label
          : this.state.customerAcquisitionType == 'Indirect Customer'
            ? this.state.indirectCustomerName
            : null),
      zone: this.state.zone || '',
      // serviceManager: clientDetail.serviceManager || null,
      // customerSuccessManager: clientDetail.customerSuccessManager || null,
      serviceManager: this.state.serviceManager || '',
      customerSuccessManager: this.state.customerSuccessManager || '',
      serviceType: this.state.selectedServiceType,
      registrationType: this.state.customerType,
      clientCategory: this.state.clientCategory,
      additionalContactNumbers: this.state.isAdditionalContact
        ? this.state.additionalContactNumbers
        : ''
    }

    if (this.state.typeOfClient === 'NON-COMMERCIAL') {
      variables['expiryDate'] = moment(this.state.expiryDateTime)
        .unix()
        .toString()
    }

    const { data, errors } = await client.mutate({
      mutation: UPDATE_CLIENT,
      variables,
      errorPolicy: 'all',
      refetchQueries: ['allClientDetails']
    })

    if (data) {
      await client.clearStore()
      this.props.openSnackbar('Updated Successfully')
      this.setState({
        clientId: '',
        companyName: '',
        username: '',
        person: '',
        secondaryContactNumber: '',
        secondaryEmail: '',
        secondaryContactName: '',
        password: '',
        clientType: '',
        email: '',
        phoneno: '',
        address: '',
        // billingAddress2: '',
        // shippingAddress2: '',
        city: '',
        // customerAddress:'',
        // address:'',
        state: '',
        country: '',
        shippingState: '',
        shippingCountry: '',
        pincode: '',
        shippingAddress: '',
        shippingCity: '',
        shippingPincode: '',
        pan: '',
        gst: '',
        selectedPlan: '',
        // selectedSolutionMaster: '',
        timezone: '',
        prorata: 0,
        packetThreshold: 0,
        minimumTrackedDays: 0,
        typeOfClient: 'REAL',
        expiryDateTime: moment().add(1, 'week'),
        totalPotentialVehicles: 0
      })
      this.props.history.push({
        pathname: '/home/customers'
      })
    } else {
      this.props.openSnackbar(errors[0].message)
    }
  }

  cancelForm = e => {
    // this.setState({
    //   clientId: '',
    //   companyName: '',
    //   username: '',
    //   person: '',
    //   password: '',
    //   email: '',
    //   phoneno: '',
    //   address: '',
    //   billingAddress2: '',
    //   city: '',
    //   state: '',
    //   country: '',
    //   pincode: '',
    //   pan: '',
    //   gst: '',
    //   plan: '',
    //   timezone: '',
    //   typeOfClient: 'REAL',
    //   expiryDateTime: moment().add(1, 'week')
    // })
    this.props.history.goBack()
  }

  handleTypeChange = e => {
    const { value } = e.target
    console.log('typeof client :', value)
    this.setState({
      typeOfClient: e.target.value,
      isStateChanged: true
    })
    if (value === 'DEMO') {
      this.setState({
        expiryDateTime: moment().add(1, 'month'),
        isStateChanged: true
      })
    } else {
      this.setState({
        expiryDateTime: moment().add(1, 'week'),
        isStateChanged: true
      })
    }
  }

  getGstInfo = async gstNumber => {
    const fetchGstData = await this.props.client.query({
      query: GET_GST_INFO,
      variables: {
        gstNumber: gstNumber
      }
    })

    this.setState({
      isGstInfoAvailable: fetchGstData.data.getGstDetails.status === 'SUCCESS',
      pan:
        fetchGstData.data.getGstDetails.panNumber != null
          ? fetchGstData.data.getGstDetails.panNumber
          : null,
      companyName:
        fetchGstData.data.getGstDetails.companyName != null
          ? fetchGstData.data.getGstDetails.companyName
          : null,
      address:
        fetchGstData.data.getGstDetails.address != null
          ? fetchGstData.data.getGstDetails.address
          : null,
      pincode:
        fetchGstData.data.getGstDetails.pinCode != null
          ? fetchGstData.data.getGstDetails.pinCode
          : null
    })
  }

  isSaveFormInvalid() {
    const {
      customerType,
      customerAcquisitionType,
      directCustomerType,
      directCustomer,
      indirectCustomerType,
      channelPartnerType,
      channelPartnerName,
      customerLocation,
      customerAddress,
      country,
      pincode,
      state,
      city,
      timezone,
      zone,
      selectedZM,
      selectedStateManager,
      selectedTerritoryManager,
      selectedSalesHead,
      selectedClusterHead,
      selectedStateHead,
      selectedCityManager,
      selectedOperationsManager,
      selectedKAM,
      serviceManager,
      customerSuccessManager,
      isUsernameValid,
      isPasswordValid,
      customerNameToBeDisplayed,
      totalPotentialVehicles,
      contactPerson,
      isContactpValid1,
      contactNumber,
      isPhonenoValid1,
      isPhoneExists,
      landlineNumberError,
      isEmailValid1,
      isEmailExists,
      isContactpValid2,
      isPhonenoValid2,
      secondaryLandlineNumberError,
      isEmailValid2,
      selectedMode,
      selectedPlan,
      // selectedSolutionMaster,
      // plan,
      selectedVTM,
      selectedServiceType,
      isSecondaryContact,
      secondaryContactName,
      secondaryContactNumber,
      secondaryEmail,
      isAdditionalContact,
      additionalContactNumbers,
      isAdditionalContactValid,
      clientNameRes,
      clientCategory
    } = this.state

    return (
      !customerType ||
      !customerAcquisitionType ||
      (customerAcquisitionType === 'Direct Customer' &&
        (!directCustomerType || !directCustomer)) ||
      (customerAcquisitionType === 'Indirect Customer' &&
        (!indirectCustomerType ||
          !channelPartnerName ||
          !channelPartnerType)) ||
      !customerLocation ||
      !customerAddress ||
      !country ||
      !pincode ||
      !state ||
      !city ||
      !timezone ||
      // !zone ||
      // !selectedZM ||
      // !selectedStateManager ||
      // !selectedTerritoryManager ||
      // !selectedSalesHead ||
      // !selectedClusterHead ||
      // !selectedStateHead ||
      // !selectedCityManager ||
      // !selectedOperationsManager ||
      // !selectedKAM ||
      // !serviceManager ||
      // !customerSuccessManager ||
      !isUsernameValid ||
      !isPasswordValid ||
      clientNameRes ||
      (this.state.customerAcquisitionType === 'Direct Customer'
        ? this.state.customerNameToBeDisplayed ||
          (this.state.directCustomer ? this.state.directCustomer.label : '')
        : this.state.customerAcquisitionType === 'Indirect Customer'
          ? this.state.customerNameToBeDisplayed ||
            this.state.indirectCustomerName
          : this.state.customerNameToBeDisplayed || '') === '' ||
      !totalPotentialVehicles ||
      !contactPerson ||
      !isContactpValid1 ||
      !contactNumber ||
      !isPhonenoValid1 ||
      !isPhoneExists ||
      landlineNumberError ||
      !isEmailValid1 ||
      !isEmailExists ||
      !selectedMode ||
      // commenting Selected plan as we are moving from plan to Solution Based
      // !selectedPlan ||
      // !selectedSolutionMaster ||
      !selectedServiceType ||
      (isSecondaryContact &&
        (!secondaryContactName ||
          !isContactpValid2 ||
          !isPhonenoValid2 ||
          secondaryLandlineNumberError ||
          !isEmailValid2 ||
          !secondaryContactNumber ||
          !secondaryEmail)) ||
      (isAdditionalContact &&
        (!additionalContactNumbers || !isAdditionalContactValid)) ||
      !clientCategory
    )
  }

  render() {
    const {
      companyName,
      username,
      person,
      clientType,
      registrationType,
      customerAcquisitionType,
      secondaryContactName,
      isSecondaryContact,
      secondaryContactNumber,
      secondaryEmail,
      email,
      phoneno,
      address,
      // billingAddress2,
      // shippingAddress2,
      shippingAddress,
      shippingCity,
      shippingPincode,
      city,
      state,
      country,
      shippingCountry,
      shippingState,
      pincode,
      pan,
      gst,
      isGstEdited,
      gstErrorFieldText,
      selectedPlan,
      // selectedSolutionMaster,
      typeOfClient,
      solution,
      billingMode,
      prorata,
      minimumTrackedDays,
      packetThreshold,
      salesPerson,
      allSalesPerson,
      showFields,
      selectedMode,
      selectedVTM,
      selectedServiceType,
      secondaryLandlineNumber,
      selectedZM,
      selectedStateManager,
      selectedTerritoryManager,
      selectedSalesHead,
      selectedClusterHead,
      selectedStateHead,
      selectedCityManager,
      selectedOperationsManager,
      selectedKAM,
      indirectCustomerName,
      directCustomerType,
      directCustomerSAPCode,
      directCustomer,
      indirectCustomerType,
      channelPartnerType,
      channelPartnerName,
      channelPartnerNameSAPCode,
      customerLocation,
      customerAddress,
      timezone,
      customerNameToBeDisplayed,
      zone,
      serviceManager,
      customerSuccessManager,
      landlineNumber,
      contactNumber,
      contactPerson,
      clientCategory,
      clientCategoryOptions
    } = this.state

    const { classes } = this.props

    return (
      // <Query
      //   query={GET_ALL_PLANS}
      //   variables={{
      //     partnerLoginId: getLoginId()
      //   }}
      //   fetchPolicy="network-only"
      // >
      //   {({ loading, error, data: { allPlans } }) => {
      //     if (loading) return <Loader />
      //     if (error) return `Error!: ${error}`

      //     const plans = allPlans.map(plan => ({
      //       value: plan.id,
      //       label: plan.planName
      //     }))
      <Query query={GET_ALL_SOLUTION_TYPE_MASTER} fetchPolicy="network-only">
        {({ loading, error, data }) => {
          if (loading) return <Loader />
          if (error) return `Error!: ${error}`

          // Map solutions to value/label format
          const solutionsMaster = data.getAllMasterSolutionType.map(
            solution => ({
              value: solution.id,
              label: solution.solutionTypeName
            })
          )

          return (
            <div className={classes.root}>
              <ConfirmationalDialog
                isDialogOpen={this.state.isSaveConfDialogOpen}
                dialogMessage={
                  "Are you sure you want to Save this customer's details?"
                }
                negativeResponseHandler={this.handleSaveNegativeResponse}
                positiveResponseHandler={this.submitForm(this.props.client)}
              />
              <ConfirmationalDialog
                isDialogOpen={this.state.isCancelConfDialogOpen}
                dialogMessage={
                  'Are you sure you want to Cancel new customer creation?'
                }
                negativeResponseHandler={this.handleCancelNegativeResponse}
                positiveResponseHandler={this.cancelForm}
              />
              <Grid container spacing={16}>
                <Grid item xs={12} justify="flex-start">
                  <Button
                    variant="outlined"
                    color="secondary"
                    className={classes.button}
                    onClick={this.handleCancelClick}
                  >
                    <ArrowBackIcon />
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Card>
                    <CardHeader
                      title="Edit Customer"
                      subheader="All fields marked with (*) are mandatory"
                      subheaderTypographyProps={{
                        className: classes.italicizedText
                      }}
                    />
                    <CardContent>
                      <Grid container spacing={16}>
                        <Grid item xs={12} md={6} style={{ zIndex: '20' }}>
                          <label>Customer Type *</label>
                          <FormGroup
                            className="form-input"
                            style={{ marginTop: '10px' }}
                          >
                            <Select
                              options={
                                Array.isArray(this.state.customertype) &&
                                this.state.customertype.map(option => ({
                                  label: option,
                                  value: option
                                }))
                              }
                              value={this.state.customerType}
                              onChange={this.handleCustomerTypeChange}
                              placeholder="Select Customer Type *"
                            />
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6} style={{ zIndex: '15' }}>
                          <label>Customer Acquisition Type *</label>
                          <FormGroup
                            className="form-input"
                            style={{ marginTop: '10px' }}
                          >
                            <Select
                              options={
                                Array.isArray(
                                  this.state.customeracquisitiontype
                                ) &&
                                this.state.customeracquisitiontype.map(
                                  option => ({
                                    label: option,
                                    value: option
                                  })
                                )
                              }
                              value={customerAcquisitionType}
                              onChange={
                                this.handleCustomerAcquisitionTypeChange
                              }
                              placeholder="Select Customer Acquisition Type *"
                            />
                          </FormGroup>
                        </Grid>

                        {customerAcquisitionType === 'Direct Customer' && (
                          <Grid item xs={12} md={6} style={{ zIndex: '15' }}>
                            <label>Direct Customer Type *</label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '10px' }}
                            >
                              <Select
                                options={
                                  Array.isArray(
                                    this.state.directcustomertype
                                  ) &&
                                  this.state.directcustomertype.map(option => ({
                                    label: option,
                                    value: option
                                  }))
                                }
                                value={directCustomerType}
                                onChange={selectedOption => {
                                  this.setState({
                                    directCustomerType: selectedOption
                                      ? selectedOption.value
                                      : ''
                                  })
                                }}
                                required
                                placeholder="Select Direct Customer Type *"
                              />
                            </FormGroup>
                          </Grid>
                        )}

                        {customerAcquisitionType === 'Direct Customer' && (
                          <Grid
                            item
                            xs={6}
                            style={{ zIndex: '13', marginTop: '5px' }}
                          >
                            <label>Direct Customer Name *</label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Query
                                query={GET_SAP_DETAILS}
                                variables={{
                                  directCustomerSapCode: this.state
                                    .existingDirectCustomerSAPCode
                                }}
                              >
                                {({ loading, error, data }) => {
                                  if (loading) return 'Loading...'
                                  if (error) return `Error!: ${error.message}`

                                  const newCustomers = data.getSapDetails.map(
                                    customer => ({
                                      value: customer.customer_no,
                                      label: customer.customer_name
                                    })
                                  )

                                  return (
                                    <div>
                                      <Select
                                        options={newCustomers}
                                        value={directCustomer}
                                        onChange={selectedOption => {
                                          this.setState({
                                            directCustomer: selectedOption,
                                            directCustomerSAPCode: selectedOption
                                              ? selectedOption.value
                                              : '',
                                            customerNameToBeDisplayed: selectedOption
                                              ? selectedOption.label
                                              : ''
                                          })
                                        }}
                                        required
                                        placeholder="Select Direct Customer Name *"
                                        onBlur={event => {
                                          this.checkNameValidity(
                                            this.props.client
                                          )(event)
                                        }}
                                      />
                                    </div>
                                  )
                                }}
                              </Query>
                            </FormGroup>
                          </Grid>
                        )}

                        {customerAcquisitionType === 'Direct Customer' && (
                          <Grid item xs={12} md={6} style={{ zIndex: '13' }}>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <label>Direct Customer SAP Code</label>
                              <TextField
                                id="directCustomerSAPCode"
                                name="directCustomerSAPCode"
                                className="textfield"
                                margin="dense"
                                type="text"
                                value={directCustomerSAPCode}
                                onChange={this.handleInputChangeNew(
                                  'directCustomerSAPCode'
                                )}
                                InputProps={{ readOnly: true }}
                              />
                            </FormGroup>
                          </Grid>
                        )}

                        {customerAcquisitionType === 'Indirect Customer' && (
                          <Grid item xs={12} md={6} style={{ zIndex: '15' }}>
                            <label>Indirect Customer Type *</label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '10px' }}
                            >
                              <Select
                                // options={INDIRECT_CUSTOMER_TYPE_OPTIONS}
                                options={
                                  Array.isArray(
                                    this.state.indirectcustomertype
                                  ) &&
                                  this.state.indirectcustomertype.map(
                                    option => ({
                                      label: option,
                                      value: option
                                    })
                                  )
                                }
                                value={indirectCustomerType}
                                onChange={selectedOption => {
                                  this.setState({
                                    indirectCustomerType: selectedOption
                                      ? selectedOption.value
                                      : ''
                                  })
                                }}
                                required
                                placeholder="Select Indirect Customer Type *"
                              />
                            </FormGroup>
                          </Grid>
                        )}

                        {customerAcquisitionType === 'Indirect Customer' && (
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ zIndex: '13', marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                id="indirectCustomerName"
                                name="indirectCustomerName"
                                className="textfield"
                                margin="dense"
                                label="Indirect Customer Name"
                                type="text"
                                value={indirectCustomerName}
                                onChange={this.handleInputChangeIndirectCustomerName(
                                  'indirectCustomerName'
                                )}
                                onBlur={event => {
                                  this.checkNameValidity(this.props.client)(
                                    event
                                  )
                                }}
                              />
                            </FormGroup>
                          </Grid>
                        )}

                        {customerAcquisitionType === 'Indirect Customer' && (
                          <Grid item xs={12} md={6} style={{ zIndex: '12' }}>
                            <label>Channel Partner Name *</label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '10px' }}
                            >
                              <Select
                                options={
                                  this.state.channelPartnerSAPCodeNew &&
                                  this.state.channelPartnerSAPCodeNew.map(
                                    option => ({
                                      label: option.channel_partner_name,
                                      value: option.channel_partner_name
                                    })
                                  )
                                }
                                value={channelPartnerName}
                                onChange={selectedOption => {
                                  this.setState({
                                    channelPartnerName: selectedOption
                                      ? selectedOption.value
                                      : '',
                                    channelPartnerSAPCode: selectedOption
                                      ? this.state.channelPartnerSAPCodeNew.find(
                                          customer =>
                                            customer.channel_partner_name ===
                                            selectedOption.value
                                        )
                                        ? this.state.channelPartnerSAPCodeNew.find(
                                            customer =>
                                              customer.channel_partner_name ===
                                              selectedOption.value
                                          ).channel_partner_sap_code
                                        : '99999999'
                                      : '',
                                    channelPartnerType: selectedOption
                                      ? this.state.channelPartnerSAPCodeNew.find(
                                          customer =>
                                            customer.channel_partner_name ===
                                            selectedOption.value
                                        )
                                        ? this.state.channelPartnerSAPCodeNew.find(
                                            customer =>
                                              customer.channel_partner_name ===
                                              selectedOption.value
                                          ).channel_partner_type
                                        : 'N/A'
                                      : ''
                                  })
                                }}
                                required
                                placeholder="Select Channel Partner Name *"
                              />
                            </FormGroup>
                          </Grid>
                        )}

                        {customerAcquisitionType === 'Indirect Customer' && (
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ zIndex: '2', marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <label>Channel Partner Type</label>
                              <TextField
                                id="channelPartnerType"
                                name="channelPartnerType"
                                className="textfield"
                                margin="dense"
                                type="text"
                                value={this.state.channelPartnerType}
                                onChange={this.handleInputChangeNew(
                                  'channelPartnerType'
                                )}
                                InputProps={{ readOnly: true }}
                              />
                            </FormGroup>
                          </Grid>
                        )}

                        {customerAcquisitionType === 'Indirect Customer' && (
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ zIndex: '2', marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <label>Channel Partner SAP Code</label>
                              <TextField
                                id="channelPartnerSAPCode"
                                name="channelPartnerSAPCode"
                                className="textfield"
                                margin="dense"
                                type="text"
                                value={this.state.channelPartnerSAPCode}
                                onChange={this.handleInputChangeNew(
                                  'channelPartnerSAPCode'
                                )}
                                InputProps={{ readOnly: true }}
                              />
                            </FormGroup>
                          </Grid>
                        )}

                        <Grid item xs={12} md={12}>
                          <p style={{ fontSize: '24px' }}>Location Info</p>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{ zIndex: '7', marginTop: '-20px' }}
                        >
                          <label>Customer Location *</label>
                          <FormGroup
                            className="form-input"
                            style={{ marginTop: '5px' }}
                          >
                            <Select
                              options={
                                Array.isArray(this.state.customerlocation) &&
                                this.state.customerlocation.map(option => ({
                                  label: option,
                                  value: option
                                }))
                              }
                              value={customerLocation}
                              onChange={selectedOption => {
                                this.setState({
                                  customerLocation: selectedOption
                                    ? selectedOption.value
                                    : 'India'
                                })
                              }}
                              required
                              placeholder="Select Customer Location *"
                            />
                          </FormGroup>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{ marginTop: '-10px' }}
                        >
                          <label>Customer Address *</label>
                          <FormGroup className="form-input">
                            <TextField
                              name="customerAddress"
                              value={customerAddress}
                              type="text"
                              onChange={this.handleInputChangeNew(
                                'customerAddress'
                              )}
                            />
                          </FormGroup>
                        </Grid>

                        <Grid
                          item
                          xs={6}
                          style={{ zIndex: '6', marginTop: '5px' }}
                        >
                          <label>Country *</label>
                          <FormGroup
                            className="form-input"
                            style={{ marginTop: '5px' }}
                          >
                            <Query query={GET_COUNTRIES}>
                              {({ loading, error, data: { allCountries } }) => {
                                if (loading) return 'Loading...'
                                if (error) return `Error!: ${error}`

                                const sortedCountries = allCountries.map(
                                  country => ({
                                    value: country.country_id,
                                    label: country.name
                                  })
                                )

                                return (
                                  <div>
                                    <Select
                                      options={sortedCountries}
                                      value={country}
                                      onChange={selectedOption => {
                                        this.setState({
                                          country: selectedOption
                                            ? selectedOption.value
                                            : ''
                                        })
                                      }}
                                      required
                                      placeholder="Select Country *"
                                    />
                                  </div>
                                )
                              }}
                            </Query>{' '}
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6} style={{ marginTop: '15px' }}>
                          <FormGroup className="form-input">
                            <TextField
                              name="pincode"
                              value={pincode}
                              type="text"
                              onChange={this.handlePincodeChange}
                              label="Enter PIN Code *"
                            />
                          </FormGroup>
                        </Grid>

                        <Grid
                          item
                          xs={6}
                          style={{ zIndex: '5', marginTop: '5px' }}
                        >
                          <label>State *</label>
                          <FormGroup
                            className="form-input"
                            style={{ marginTop: '5px' }}
                          >
                            <Query
                              query={GET_STATES_FOR_COUNTRY}
                              variables={{
                                countryId: Number(this.state.country)
                                  ? this.state.country
                                  : 99
                              }}
                            >
                              {({ loading, error, data }) => {
                                if (loading) return 'Loading...'
                                if (error) return `Error!: ${error}`

                                if (data && data.allStatesByCountryId) {
                                  const sortedStates = data.allStatesByCountryId.map(
                                    state => ({
                                      value: state.zone_id,
                                      label: state.name
                                    })
                                  )

                                  if (sortedStates.length > 0) {
                                    return (
                                      <div>
                                        <Select
                                          options={sortedStates}
                                          value={
                                            sortedStates.find(
                                              option =>
                                                option.value ===
                                                this.state.state
                                            ) || null
                                          }
                                          onChange={selectedOption => {
                                            this.setState({
                                              state: selectedOption
                                                ? selectedOption.value
                                                : ''
                                            })
                                          }}
                                          required
                                          placeholder="Select State *"
                                        />
                                      </div>
                                    )
                                  } else {
                                    return (
                                      <TextField
                                        value="No States in this Country"
                                        type="text"
                                      />
                                    )
                                  }
                                }

                                return null
                              }}
                            </Query>
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6} style={{ marginTop: '15px' }}>
                          <FormGroup className="form-input">
                            <TextField
                              name="city"
                              value={city}
                              type="text"
                              onChange={this.handleInputChangeNew('city')}
                              label="Enter City *"
                            />
                          </FormGroup>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{ zIndex: '4', marginTop: '5px' }}
                        >
                          <label>Time Zone *</label>
                          <FormGroup
                            className="form-input"
                            style={{ marginTop: '5px' }}
                          >
                            <Select
                              options={this.state.timezoneList}
                              value={timezone}
                              onChange={this.handleTimezoneChange}
                              placeholder="Select Time Zone *"
                            />
                          </FormGroup>
                        </Grid>

                        <Grid
                          container
                          spacing={2}
                          style={{ marginTop: '20px' }}
                        >
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ zIndex: '3', marginTop: '5px' }}
                          >
                            <label>Zone *</label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={ZONE_OPTIONS}
                                value={zone}
                                onChange={selectedOption => {
                                  this.setState({
                                    zone: selectedOption
                                      ? selectedOption.value
                                      : ''
                                  })
                                }}
                                placeholder="Select Zone *"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '5px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              Zonal Manager
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.zonalManagers.map(zm => ({
                                  label: zm.username,
                                  value: zm.id
                                }))}
                                value={selectedZM}
                                onChange={this.handleZMChange}
                                placeholder="Select Zonal Manager"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '15px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              State Manager
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.stateManagers.map(sm => ({
                                  label: sm.username,
                                  value: sm.id
                                }))}
                                value={this.state.selectedStateManager}
                                onChange={this.handleStateManagerChange}
                                placeholder="Select State Manager"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '15px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              Territory Manager
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.territoryManagers.map(
                                  tm => ({
                                    label: tm.username,
                                    value: tm.id
                                  })
                                )}
                                value={selectedTerritoryManager}
                                onChange={this.handleTerritoryManagerChange}
                                placeholder="Select Territory Manager"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '15px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              Sales Head
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.salesHeads.map(sh => ({
                                  label: sh.username,
                                  value: sh.id
                                }))}
                                value={selectedSalesHead}
                                onChange={this.handleSalesHeadChange}
                                placeholder="Select Sales Head"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '15px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              Cluster Head
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.clusterHeads.map(ch => ({
                                  label: ch.username,
                                  value: ch.id
                                }))}
                                value={selectedClusterHead}
                                onChange={this.handleClusterHeadChange}
                                placeholder="Select Cluster Head"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '15px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              State Head
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.stateHeads.map(sh => ({
                                  label: sh.username,
                                  value: sh.id
                                }))}
                                value={selectedStateHead}
                                onChange={this.handleStateHeadChange}
                                placeholder="Select State Head"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '15px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              City Manager
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.cityManagers.map(cm => ({
                                  label: cm.username,
                                  value: cm.id
                                }))}
                                value={selectedCityManager}
                                onChange={this.handleCityManagerChange}
                                placeholder="Select City Manager"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '15px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              Operations Manager
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.operationsManagers.map(
                                  om => ({
                                    label: om.username,
                                    value: om.id
                                  })
                                )}
                                value={selectedOperationsManager}
                                onChange={this.handleOperationsManagerChange}
                                placeholder="Select Operations Manager"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '15px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              Key Account Manager
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.keyAccountManagers.map(
                                  kam => ({
                                    label: kam.username,
                                    value: kam.id
                                  })
                                )}
                                value={selectedKAM}
                                onChange={this.handleKAMChange}
                                placeholder="Select Key Account Manager"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '15px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              Service Manager
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.serviceManagers.map(sm => ({
                                  label: sm.username,
                                  value: sm.id
                                }))}
                                value={serviceManager}
                                onChange={this.handleSMChange}
                                placeholder="Select Service Manager"
                              />
                            </FormGroup>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ marginTop: '15px' }}
                          >
                            <label style={{ marginRight: '20px' }}>
                              Customer Success Manager
                            </label>
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '5px' }}
                            >
                              <Select
                                options={this.state.customerSuccessManagers.map(
                                  csm => ({
                                    label: csm.username,
                                    value: csm.id
                                  })
                                )}
                                value={customerSuccessManager}
                                onChange={this.handleCSMChange}
                                placeholder="Select Customer Success Manager"
                              />
                            </FormGroup>
                          </Grid>
                        </Grid>
                        {getLoginId() === 2 && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <Select
                                options={allSalesPerson}
                                value={salesPerson}
                                onChange={this.handleSalesPersonChange}
                                placeholder="Select Sales Person*"
                              />
                            </FormGroup>
                          </Grid>
                        )}
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="username"
                              value={username}
                              type="text"
                              onChange={this.handleInputChangeUsernamePassword}
                              required
                              error={!this.state.isUsernameValid}
                              onBlur={this.checkUsernameValidity(
                                this.props.client
                              )}
                              label="User Name"
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isUsernameValid
                                ? this.state.usernameRes
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="password"
                              value="password"
                              type="password"
                              onChange={this.handleInputChangeUsernamePassword}
                              label="Password"
                              error={!this.state.isPasswordValid}
                              onBlur={this.checkPasswordValidity}
                              // required
                              disabled
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isPasswordValid
                                ? ''
                                : 'Password should contain 3-20 charcter or digit without space'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6} style={{ marginTop: '10px' }}>
                          <FormGroup className="form-input">
                            <label>
                              Customer Name to be displayed on Portal *
                            </label>
                            <TextField
                              name="customerNameToBeDisplayed"
                              value={
                                customerAcquisitionType === 'Direct Customer'
                                  ? customerNameToBeDisplayed ||
                                    (this.state.directCustomer
                                      ? directCustomer.label
                                      : '')
                                  : customerAcquisitionType ===
                                    'Indirect Customer'
                                    ? customerNameToBeDisplayed ||
                                      indirectCustomerName
                                    : customerNameToBeDisplayed || ''
                              }
                              type="text"
                              onChange={this.handleInputChangeNew(
                                'customerNameToBeDisplayed'
                              )}
                              error={!this.state.isNameValid}
                              onBlur={event => {
                                this.checkNameValidity(this.props.client)(event)
                              }}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.clientNameRes}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={6} style={{ marginTop: '10px' }}>
                          <FormGroup className="form-input">
                            <label>Customer Potential *</label>
                            <TextField
                              name="totalPotentialVehicles"
                              value={this.state.totalPotentialVehicles}
                              type="number"
                              onChange={this.handleInputChangeNew(
                                'totalPotentialVehicles'
                              )}
                              inputProps={{
                                name: 'totalPotentialVehicles',
                                min: 1,
                                step: 1
                              }}
                            />
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <p style={{ fontSize: '24px' }}>Contact Info</p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <InputLabel
                              htmlFor="contactPerson"
                              style={{ marginTop: '-10px' }}
                              shrink={contactPerson}
                            >
                              Primary Contact Person Name *
                            </InputLabel>
                            <TextField
                              name="contactPerson"
                              value={contactPerson}
                              type="text"
                              onChange={this.handleInputChangeNew(
                                'primaryContactPersonName'
                              )}
                              required
                              error={!this.state.isContactpValid1}
                              onBlur={this.checkContactpValidity}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isContactpValid1
                                ? ''
                                : 'Only Alphabets allowed, between 3 to 32 characters'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <InputLabel
                              htmlFor="contactPerson"
                              style={{ marginTop: '-10px' }}
                              shrink={contactPerson}
                            >
                              Primary Mobile Number *
                            </InputLabel>
                            <TextField
                              name="contactNumber"
                              value={this.state.contactNumber}
                              type="text"
                              onChange={this.handleInputChangeNew(
                                'primaryContactPersonMobileNumber'
                              )}
                              required
                              error={!this.state.isPhonenoValid1}
                              onBlur={this.checkPhonenoValidity1(
                                this.props.client
                              )}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isPhonenoValid1
                                ? ''
                                : 'Invalid Phone Number '}
                              {this.state.isPhoneExists
                                ? ''
                                : 'Phone Number Already Exists '}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="landlineNumber"
                              value={landlineNumber}
                              type="text"
                              onChange={this.handleInputChangeNew(
                                'primaryContactPersonLandlineNumber'
                              )}
                              label="Landline Number"
                              onBlur={event =>
                                this.checkLandlineValidity(
                                  event,
                                  'landlineNumber'
                                )
                              }
                              error={this.state.landlineNumberError}
                            />
                            <FormHelperText
                              id="landline-error-text"
                              className="Error_msg"
                              error={this.state.landlineNumberError}
                            >
                              {this.state.landlineNumberError}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="email"
                              value={email}
                              type="email"
                              onChange={this.handleInputChangeNew(
                                'primaryContactPersonEmail'
                              )}
                              label="Primary Email"
                              required
                              error={!this.state.isEmailValid1}
                              onBlur={this.checkEmailValidity1(
                                this.props.client
                              )}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isEmailExists
                                ? ''
                                : 'Email Id already exist '}
                              {this.state.isEmailValid1
                                ? ' '
                                : 'Invalid Email '}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={12} display="flex">
                          <Checkbox
                            name="isSecondaryContact"
                            value={isSecondaryContact}
                            checked={isSecondaryContact}
                            onClick={this.handleSecondaryContactAvailable}
                          />
                          <span style={{ fontSize: '15px' }}>
                            Secondary Contact Details Available?
                          </span>
                        </Grid>

                        {isSecondaryContact && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="secondaryContactName"
                                value={secondaryContactName}
                                type="text"
                                onChange={this.handleInputChangeNew(
                                  'secondaryContactPersonName'
                                )}
                                label="Secondary Contact Person Name *"
                                error={!this.state.isContactpValid2}
                                onBlur={this.checkContactpValidityTwo}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {this.state.isContactpValid2
                                  ? ''
                                  : 'Only Alphabets allowed, between 3 to 32 characters'}
                              </FormHelperText>
                            </FormGroup>
                          </Grid>
                        )}

                        {isSecondaryContact && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="secondaryContactNumber"
                                value={secondaryContactNumber}
                                type="text"
                                onChange={this.handleInputChangeNew(
                                  'secondaryContactPersonPhoneNumber'
                                )}
                                label="Secondary Phone Number *"
                                error={!this.state.isPhonenoValid2}
                                onBlur={this.checkPhonenoValidity2(
                                  this.props.client
                                )}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {this.state.isPhonenoValid2
                                  ? ''
                                  : // : 'Invalid phone Number'}
                                    this.state.phonenoRes2}
                              </FormHelperText>
                            </FormGroup>
                          </Grid>
                        )}

                        {isSecondaryContact && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="secondaryLandlineNumber"
                                value={secondaryLandlineNumber}
                                type="text"
                                onChange={this.handleInputChangeNew(
                                  'secondaryContactPersonLandlineNumber'
                                )}
                                label="Landline Number"
                                onBlur={event =>
                                  this.checkLandlineValidity(
                                    event,
                                    'secondaryLandlineNumber'
                                  )
                                }
                                error={
                                  !this.state.isSecondaryLandlineNumberValid
                                }
                              />
                              <FormHelperText
                                id="landline-error-text"
                                className="Error_msg"
                                error={this.state.secondaryLandlineNumberError}
                              >
                                {this.state.secondaryLandlineNumberError}
                              </FormHelperText>
                            </FormGroup>
                          </Grid>
                        )}

                        {isSecondaryContact && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="secondaryEmail"
                                value={secondaryEmail}
                                type="email"
                                onChange={this.handleInputChangeNew(
                                  'secondaryContactPersonEmail'
                                )}
                                label="Secondary Email *"
                                error={!this.state.isEmailValid2}
                                onBlur={this.checkEmailValidity2(
                                  this.props.client
                                )}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {this.state.isEmailValid2
                                  ? ''
                                  : // : 'Invalid Email'}
                                    this.state.emailRes2}
                              </FormHelperText>
                            </FormGroup>
                          </Grid>
                        )}

                        <Grid item xs={12} md={12} display="flex">
                          <Checkbox
                            name="isAdditionalContact"
                            value={this.state.isAdditionalContact}
                            checked={this.state.isAdditionalContact}
                            onClick={this.handleAdditionalContactAvailable}
                          />
                          <span style={{ fontSize: '15px' }}>
                            Additional Contact Details Available?
                          </span>
                        </Grid>

                        {this.state.isAdditionalContact && (
                          <React.Fragment>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="additionalContactNumbers"
                                  label="Additional Contact Numbers (comma separated) *"
                                  value={this.state.additionalContactNumbers}
                                  onChange={this.handleAdditionalContactChange}
                                  onBlur={this.checkAdditionalContactValidity}
                                  fullWidth
                                  error={!this.state.isAdditionalContactValid}
                                  helperText={this.state.additionalContactError}
                                />
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              {/* Empty grid item to maintain layout alignment */}
                            </Grid>
                          </React.Fragment>
                        )}

                        <Grid item xs={12} md={6} style={{ marginTop: '20px' }}>
                          <label>Mode *</label>
                          <FormGroup
                            className="form-input"
                            style={{ marginTop: '10px' }}
                          >
                            <Select
                              options={
                                Array.isArray(this.state.mode) &&
                                this.state.mode.map(option => ({
                                  label: option,
                                  value: option
                                }))
                              }
                              value={selectedMode}
                              onChange={this.handleModeChange}
                              placeholder="Select Mode *"
                            />
                          </FormGroup>
                        </Grid>

                        {/* <Grid item xs={12} md={6} style={{ marginTop: '20px' }}> */}
                        {/* 
                            <label>Plan *</label> 
                            */}
                        {/* <label>Solution *</label>
                              <FormGroup className="form-input" style={{ marginTop: '10px' }}> */}
                        {/*
                                <Select
                                  options={plans}
                                  value={selectedPlan}
                                  onChange={this.handlePlanChange}
                                  placeholder="Select Plan *"
                                /> */}
                        {/* <Select
                                  options={solutionsMaster}
                                  value={selectedSolutionMaster}
                                  onChange={this.handleSolutionMasterChange}
                                  placeholder="Select Solution *"
                                />
                              </FormGroup>
                            </Grid> */}

                        <Grid item xs={12} md={6} style={{ marginTop: '20px' }}>
                          <label>Video Telematics Plan *</label>
                          <FormGroup
                            className="form-input"
                            style={{ marginTop: '10px' }}
                          >
                            <Select
                              options={
                                Array.isArray(this.state.videotelematicsplan) &&
                                this.state.videotelematicsplan.map(option => ({
                                  label: option,
                                  value:
                                    option === 'API-Loconav'
                                      ? 'loconav'
                                      : option === 'API-Meta'
                                        ? 'mettax'
                                        : option === 'iFrame-LM'
                                          ? 'lightMetrics'
                                          : option === 'None'
                                            ? 'none'
                                            : option.toLowerCase()
                                }))
                              }
                              value={selectedVTM || 'none'}
                              onChange={this.handleVideoTelematicsMenuChange}
                              placeholder="Select Video Telematics Plan *"
                              menuStyle={{ height: '120px' }}
                            />
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6} style={{ marginTop: '20px' }}>
                          <label>Service Type *</label>
                          <FormGroup
                            className="form-input"
                            style={{ marginTop: '10px' }}
                          >
                            <Select
                              options={
                                Array.isArray(this.state.servicetype) &&
                                this.state.servicetype.map(option => ({
                                  label: option,
                                  value: option.toLowerCase()
                                }))
                              }
                              value={selectedServiceType}
                              onChange={this.handleServiceTypeChange}
                              placeholder="Select Service Type *"
                              menuStyle={{ height: '120px' }}
                            />
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={12} display="flex">
                          <Checkbox
                            name="is_sim_tracking"
                            value={this.state.is_sim_tracking}
                            checked={this.state.is_sim_tracking}
                            onClick={this.handleSimTracking}
                          />
                          <span style={{ fontSize: '15px' }}>
                            SIM tracking enabled?
                          </span>
                        </Grid>

                        <Grid item xs={12} md={6} style={{ marginTop: '20px' }}>
                          <label>Client Category *</label>
                          <FormGroup
                            className="form-input"
                            style={{ marginTop: '10px' }}
                          >
                            <Select
                              options={clientCategoryOptions}
                              value={clientCategoryOptions.find(
                                option => option.value === clientCategory
                              )}
                              onChange={selectedOption => {
                                this.setState({
                                  clientCategory: selectedOption.value
                                })
                              }}
                              placeholder="Select Client Category *"
                            />
                          </FormGroup>
                        </Grid>
                      </Grid>
                    </CardContent>
                    <CardActions>
                      <Button
                        color="secondary"
                        variant="contained"
                        onClick={this.handleSaveClick}
                        disabled={this.isSaveFormInvalid()}
                      >
                        Save
                      </Button>
                      <Button
                        color="secondary"
                        onClick={this.handleCancelClick}
                      >
                        Cancel
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              </Grid>
            </div>
          )
        }}
      </Query>
    )
  }
}

EditCustomer.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(withApollo(withSharedSnackbar(EditCustomer)))



// WEBPACK FOOTER //
// ./src/components/Pages/EditCustomer/index.jsx